<template>
	<el-dialog :title="getDialogTitle" :visible.sync="dialogVisible" width="88%" :close-on-click-modal="false"
		:before-close="handleClose" top="2vh" custom-class="addxyk-dialog">
		<!-- 表单内容 -->
		<el-form ref="inboundForm" :model="formData" :rules="formRules" label-width="120px" size="small"
			v-loading="loading">
			<!-- 上部分：采购信息 -->
			<div class="purchase-info-section">
				<h4 class="section-title">采购信息</h4>
				<el-row :gutter="20">
					<el-col :span="12">
						<el-form-item label="来源药库" prop="warehouseId" required>
							<el-select v-model="formData.warehouseId" placeholder="请选择药库"
								@change="handleWarehouseChange" style="width: 100%" :disabled="true">
								<el-option label="中药库" :value="3"></el-option>
								<el-option label="中药房" :value="4"></el-option>
							</el-select>
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="计划采购单" prop="purchasePlanId">
							<div class="plan-code-select">
								<el-select v-model="formData.purchasePlanId" placeholder="请选择计划采购单"
									@change="handlePlanCodeChange" style="width: calc(100% - 40px)"
									:loading="planOptionsLoading"
									:disabled="isViewMode || isSubmitMode || isReviewMode || isPassMode || isRollbackMode || isFastMode">
									<el-option v-for="plan in purchasePlanOptions" :key="plan.id"
										:label="plan.planNo || plan.docNum" :value="plan.id">
										<div class="plan-option">
											<span class="plan-code">{{ plan.planNo || plan.docNum }}</span>
											<span class="plan-supplier" v-if="plan.supplierName">供应商:
												{{ plan.supplierName }}</span>
										</div>
									</el-option>
								</el-select>
								<el-button
									v-if="!isViewMode && !isSubmitMode && !isReviewMode && !isPassMode && !isRollbackMode"
									type="text" icon="el-icon-menu" style="margin-left: 5px;"
									@click="openPurchasePlanDrawer" title="选择采购计划详情单"></el-button>
							</div>

							<!-- 显示当前选中的采购计划信息 -->
							<div v-if="formData.purchasePlanId" class="selected-plan-info">
								<el-tag type="success" size="small">
									已选择: {{ getSelectedPlanInfo() }}
								</el-tag>
							</div>
						</el-form-item>
					</el-col>
				</el-row>

				<el-row :gutter="20">
					<el-col :span="12">
						<el-form-item label="业务日期" prop="businessDate" required>
							<el-date-picker v-model="formData.businessDate" type="date" placeholder="选择日期"
								value-format="yyyy-MM-dd" format="yyyy-MM-dd" style="width: 100%"
								:disabled="isViewMode || isSubmitMode || isReviewMode || isPassMode || isRollbackMode || isFastMode">
							</el-date-picker>
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="发票号码" prop="invoiceNo">
							<el-input v-model="formData.invoiceNo" placeholder="请输入发票号码"
								:disabled="isViewMode || isSubmitMode || isReviewMode || isPassMode || isRollbackMode || isFastMode"></el-input>
						</el-form-item>
					</el-col>
				</el-row>

				<el-row :gutter="20">
					<el-col :span="12">
						<el-form-item label="供货单位" prop="supplierId" required>
							<div class="supplier-wrapper">
								<el-select v-model="formData.supplierId" placeholder="请选择供货单位"
									@change="handleSupplierChange" :loading="supplierLoading" class="supplier-select"
									:disabled="isViewMode || isSubmitMode || isReviewMode || isPassMode || isRollbackMode || isFastMode">
									<el-option v-for="item in supplierList" :key="item.id" :label="item.supplierName"
										:value="item.id"></el-option>
								</el-select>
								<el-button
									v-if="!isViewMode && !isSubmitMode && !isReviewMode && !isPassMode && !isRollbackMode && !isFastMode"
									type="primary" icon="el-icon-plus" size="mini" @click="handleAddSupplier"
									class="add-supplier-btn" v-el-tooltip="'添加新的供应商单位'"></el-button>
								<el-input v-model="formData.supplierCode" placeholder="供应商号码"
									class="supplier-code-input"
									:disabled="isViewMode || isSubmitMode || isReviewMode || isPassMode || isRollbackMode || isFastMode"></el-input>
							</div>
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="入库方式" prop="putinTypeId" required>
							<el-select v-model="formData.putinTypeId" placeholder="请选择入库方式" style="width: 100%"
								:disabled="isViewMode || isSubmitMode || isReviewMode || isPassMode || isRollbackMode || isFastMode">
								<el-option v-for="typed in computedPutinTypeList" :key="typed.id" :label="typed.name"
									:value="typed.id"></el-option>
							</el-select>
						</el-form-item>
					</el-col>
				</el-row>

				<el-row :gutter="20">
					<el-col :span="24">
						<el-form-item label="备注" prop="remark">
							<el-input v-model="formData.remark" type="textarea" :rows="2" placeholder="请输入备注信息"
								:disabled="isViewMode || isSubmitMode || isReviewMode || isPassMode || isRollbackMode || isFastMode"></el-input>
						</el-form-item>
					</el-col>
				</el-row>
			</div>

			<!-- 下部分：药品明细信息 -->
			<div class="medicine-detail-section">
				<div class="section-header">
					<h4 class="section-title">药品明细信息</h4>
					<el-button v-if="mode === 'add' || mode === 'edit'" type="primary" icon="el-icon-plus" size="mini"
						@click="handleAddMedicine">
						添加药品
					</el-button>
				</div>

				<!-- 药品明细表格 -->
				<el-table :data="medicineList" style="width: 100%" border size="mini" height="300"
					empty-text="暂无药品明细，请点击上方【添加药品】按钮">
					<el-table-column type="index" label="#" width="50" align="center"></el-table-column>

					<!-- 药品名称列（下拉选择框） -->
					<el-table-column label="药品名称" width="200" align="center">
						<template slot-scope="scope">
							<div class="drug-select-container">
								<el-select v-model="scope.row.drugId" filterable placeholder="请选择药品" size="mini"
									style="width: 100%" @change="handleDrugChange(scope.row)" clearable
									:clearable="canClearDrug(scope.row)" @clear="handleDrugClear(scope.row)" remote
									:remote-method="(query) => handleDrugSearch(query, scope.row)"
									:remote="canRemoteSearch(scope.row)" :loading="scope.row.drugLoading"
									@focus="handleDrugFocus(scope.row)"
									v-el-select-infinite-scroll="() => handleDrugScroll(scope.row)"
									popper-class="drug-select-popper" :disabled="!canSelectDrug(scope.row)">
									<!-- 药品选项 -->
									<el-option v-for="drug in getDrugOptionsForRow(scope.row)" :key="drug.id"
										:label="getDrugDisplayLabel(drug, scope.row)" :value="drug.id">
										<div class="drug-option">
											<!-- 使用v-html显示高亮后的药品名称 -->
											<span class="drug-name"
												v-html="getHighlightedDrugName(drug, scope.row)"></span>

											<!-- 显示规格信息 -->
											<template v-if="drug.drugSpecifications || drug.pacSpec || scope.row.spec">
												<span class="drug-spec">
													规格：{{ drug.drugSpecifications || drug.pacSpec || scope.row.spec || '' }}
												</span>
											</template>

											<!-- 显示生产厂家信息 -->
											<template v-if="drug.manufacturerName || scope.row.manufacturer">
												<span class="drug-spec">
													生产厂家：{{ drug.manufacturerName || scope.row.manufacturer || '' }}
												</span>
											</template>
										</div>
									</el-option>

									<!-- 无搜索结果时的提示 -->
									<div v-if="showNoSearchResults(scope.row)" slot="empty" class="no-search-results">
										<i class="el-icon-search"></i>
										<span>未找到"{{ scope.row.drugSearchQuery || this.drugSearchQuery }}"相关药品</span>
									</div>

									<!-- 加载更多选项 -->
									<el-option v-if="drugHasMore && !drugSearchLoading && canLoadMore(scope.row)"
										:key="`load-more-${scope.row.id}-${Date.now()}`" value="load-more"
										label="点击加载更多" @click.native="loadMoreDrugs(scope.row)">
										<div class="load-more-option" @click.stop="loadMoreDrugs(scope.row)">
											<i class="el-icon-loading" v-if="loadingMoreDrugs"></i>
											<span v-else>点击加载更多</span>
										</div>
									</el-option>
								</el-select>
							</div>
						</template>
					</el-table-column>

					<el-table-column label="入库数量" width="160" align="center">
						<template slot-scope="scope">
							<div class="qty-wrapper">
								<el-input v-model="scope.row.inboundQty" size="mini"
									@change="calculateRowAmount(scope.row)" class="qty-input"
									:disabled="isViewMode || isSubmitMode || isReviewMode || isPassMode || isRollbackMode || isFastMode"></el-input>
								<span class="unit-label">{{ scope.row.unitLabel || '单位' }}</span>
							</div>
						</template>
					</el-table-column>

					<el-table-column label="库存类型" width="120" align="center">
						<template slot-scope="scope">
							<el-select v-model="scope.row.purcType" placeholder="类型" size="mini"
								@change="handlePurcTypeChange(scope.row)" style="width: 100%"
								:disabled="isViewMode || isSubmitMode || isReviewMode || isPassMode || isRollbackMode || isFastMode">
								<el-option label="最小单位" :value="1"></el-option>
								<el-option label="包装单位" :value="2"></el-option>
							</el-select>
						</template>
					</el-table-column>

					<el-table-column prop="packageQty" label="包装数量" width="100" align="center">
						<template slot-scope="scope">
							<el-input v-model="scope.row.packageQty" size="mini" :disabled="true"></el-input>
						</template>
					</el-table-column>

					<el-table-column prop="manuLotnum" label="生产批号" width="120" align="center">
						<template slot-scope="scope">
							<el-input v-model="scope.row.manuLotnum" placeholder="批号" size="mini"
								@blur="validateRequired(scope.row, 'manuLotnum')"
								:disabled="isViewMode || isSubmitMode || isReviewMode || isPassMode || isRollbackMode || isFastMode"></el-input>
						</template>
					</el-table-column>

					<!-- 生产厂家列 - 根据不同模式显示不同内容 -->
					<el-table-column label="生产厂家" width="150" show-overflow-tooltip>
						<template slot-scope="scope">
							<!-- 详情、提交、审核、过单、回退模式：只显示文本 -->
							<template v-if="isViewMode || isSubmitMode || isReviewMode || isPassMode || isRollbackMode">
								<div class="manufacturer-readonly">
									{{ scope.row.manufacturer || '--' }}
									<el-tag
										v-if="scope.row.manufacturerOptions && scope.row.manufacturerOptions.length > 1"
										size="mini" type="info" style="margin-left: 5px;">
										{{ scope.row.manufacturerOptions.length }}个厂商
									</el-tag>
								</div>
							</template>

							<!-- 新增模式：显示下拉选择框 -->
							<template v-else-if="mode === 'add'">
								<el-select v-model="scope.row.prodentpNameId" placeholder="请选择厂家" size="mini"
									@change="handleManufacturerChange(scope.row)" style="width: 100%" :disabled="false"
									:loading="scope.row.manufacturerLoading">
									<el-option v-for="manufacturer in scope.row.manufacturerOptions"
										:key="manufacturer.prodentpId" :label="manufacturer.prodentpName"
										:value="manufacturer.prodentpId"></el-option>
								</el-select>
							</template>

							<!-- 修改模式：根据行类型显示不同内容 -->
							<template v-else-if="mode === 'edit'">
								<!-- 原始数据行：只显示文本 -->
								<template v-if="!scope.row.isNewRow">
									<div class="manufacturer-readonly">
										{{ scope.row.manufacturer || '--' }}
										<el-tag
											v-if="scope.row.manufacturerOptions && scope.row.manufacturerOptions.length > 1"
											size="mini" type="info" style="margin-left: 5px;">
											{{ scope.row.manufacturerOptions.length }}个厂商
										</el-tag>
									</div>
								</template>
								<!-- 新增行：显示下拉选择框 -->
								<template v-else>
									<el-select v-model="scope.row.prodentpNameId" placeholder="请选择厂家" size="mini"
										@change="handleManufacturerChange(scope.row)" style="width: 100%"
										:disabled="false" :loading="scope.row.manufacturerLoading">
										<el-option v-for="manufacturer in scope.row.manufacturerOptions"
											:key="manufacturer.prodentpId" :label="manufacturer.prodentpName"
											:value="manufacturer.prodentpId"></el-option>
									</el-select>
								</template>
							</template>

							<!-- 默认情况 -->
							<template v-else>
								<div class="manufacturer-readonly">
									{{ scope.row.manufacturer || '--' }}
								</div>
							</template>
						</template>
					</el-table-column>

					<el-table-column label="生产日期" width="140" align="center">
						<template slot-scope="scope">
							<el-date-picker v-model="scope.row.manuDate" type="date" placeholder="生产日期"
								value-format="yyyy-MM-dd" format="yyyy-MM-dd" size="mini" style="width: 100%"
								:picker-options="getManuDatePickerOptions(scope.row)"
								@change="handleManuDateChange(scope.row)"
								:disabled="isViewMode || isSubmitMode || isReviewMode || isPassMode || isRollbackMode || isFastMode"></el-date-picker>
						</template>
					</el-table-column>

					<el-table-column label="有效日期" width="140" align="center">
						<template slot-scope="scope">
							<el-date-picker v-model="scope.row.expyDate" type="date" placeholder="有效日期"
								value-format="yyyy-MM-dd" format="yyyy-MM-dd" size="mini" style="width: 100%"
								:picker-options="getExpiryDatePickerOptions(scope.row)"
								@change="handleExpiryDateChange(scope.row)"
								:disabled="scope.row.expyDateDisabled || isViewMode || isSubmitMode || isReviewMode || isPassMode || isRollbackMode || isFastMode"></el-date-picker>
						</template>
					</el-table-column>

					<el-table-column prop="costPric" label="成本" width="160" align="right">
						<template slot-scope="scope">
							<el-input-number v-model="scope.row.costPric" :min="0" :step="0.00000001" size="mini"
								@change="handleCostPriceChange(scope.row)" :formatter="value => formatDecimal(value, 8)"
								:parser="value => parseFloat(value) || 0"
								:disabled="isViewMode || isSubmitMode || isReviewMode || isPassMode || isRollbackMode || isFastMode">
								<!-- <template slot="append">元</template> -->
							</el-input-number>
						</template>
					</el-table-column>

					<el-table-column prop="totalCost" label="总成本" width="120" align="right">
						<template slot-scope="scope">
							<span>¥{{ scope.row.totalCost ? formatDecimal(scope.row.totalCost, 8) : '0.00' }}</span>
						</template>
					</el-table-column>

					<el-table-column prop="salePric" label="零售" width="120" align="right">
						<template slot-scope="scope">
							<el-input v-model="scope.row.salePric" :min="0" :step="0.00000001" :precision="8"
								size="mini" :disabled="true" :formatter="value => formatDecimal(value, 8)"
								:parser="value => parseFloat(value) || 0">
								<!-- <template slot="append">元</template> -->
							</el-input>
						</template>
					</el-table-column>

					<el-table-column prop="totalRetail" label="总零售" width="120" align="right">
						<template slot-scope="scope">
							<span>¥{{ scope.row.totalRetail ? formatDecimal(scope.row.totalRetail, 8) : '0.00' }}</span>
						</template>
					</el-table-column>

					<el-table-column prop="markupMethodText" label="加成方式" width="120" align="center">
						<template slot-scope="scope">
							<el-input v-model="scope.row.markupMethodText" size="mini" :disabled="true"
								style="width: 100%"></el-input>
						</template>
					</el-table-column>

					<!-- 是否指定售价列 -->
					<el-table-column prop="isFixedPriceText" label="是否指定售价" width="120" align="center">
						<template slot-scope="scope">
							<el-input v-model="scope.row.isFixedPriceText" size="mini" :disabled="true"
								style="width: 100%"></el-input>
						</template>
					</el-table-column>

					<el-table-column prop="spec" label="规格" width="100" show-overflow-tooltip>
						<template slot-scope="scope">
							<el-tooltip :content="scope.row.spec || '--'" placement="top"
								:disabled="!scope.row.spec || scope.row.spec.length <= 10">
								<span>{{ scope.row.spec ? (scope.row.spec.length > 10 ? scope.row.spec.substring(0, 10) + '...' : scope.row.spec) : '--' }}</span>
							</el-tooltip>
						</template>
					</el-table-column>

					<el-table-column prop="packageSpec" label="包装规格" width="100" show-overflow-tooltip>
						<template slot-scope="scope">
							<el-tooltip :content="scope.row.packageSpec || '--'" placement="top"
								:disabled="!scope.row.packageSpec || scope.row.packageSpec.length <= 10">
								<span>{{ scope.row.packageSpec ? (scope.row.packageSpec.length > 10 ? scope.row.packageSpec.substring(0, 10) + '...' : scope.row.packageSpec) : '--' }}</span>
							</el-tooltip>
						</template>
					</el-table-column>

					<el-table-column
						v-if="!isViewMode && !isSubmitMode && !isReviewMode && !isPassMode && !isRollbackMode && !isFastMode"
						label="操作" width="180" align="center" fixed="right">
						<template slot-scope="scope">
							<el-button type="text" size="mini" @click="handleAddManufacturer(scope.row)"
								:disabled="!canAddManufacturer(scope.row)">
								添加厂商
							</el-button>
							<el-button type="text" size="mini" style="color: #F56C6C;"
								@click="handleRemoveMedicine(scope.$index, scope.row)">
								移除
							</el-button>
						</template>
					</el-table-column>
				</el-table>

				<!-- 汇总信息 -->
				<div class="summary-info">
					<el-row :gutter="20">
						<el-col :span="6">
							<div class="summary-item">
								<span class="label">药品数量：</span>
								<span class="value">{{ medicineList.length }}</span>
							</div>
						</el-col>
						<el-col :span="6">
							<div class="summary-item">
								<span class="label">总入库数量：</span>
								<span class="value">{{ totalInboundQty }}</span>
							</div>
						</el-col>
						<el-col :span="6">
							<div class="summary-item">
								<span class="label">总成本：</span>
								<span class="value">¥{{ formatCurrency(totalCost) }}</span>
							</div>
						</el-col>
						<el-col :span="6">
							<div class="summary-item">
								<span class="label">总零售：</span>
								<span class="value">¥{{ formatCurrency(totalRetail) }}</span>
							</div>
						</el-col>
					</el-row>
				</div>
			</div>
		</el-form>

		<span slot="footer" class="dialog-footer">
			<!-- 查看模式：只显示关闭按钮 -->
			<template v-if="isViewMode">
				<el-button size="small" @click="handleClose">
					关闭
				</el-button>
			</template>

			<!-- 新增模式 -->
			<template v-else-if="mode === 'add'">
				<el-button size="small" @click="handleClose">
					取消
				</el-button>
				<el-button type="primary" size="small" @click="handleCreate" :loading="saving"
					:disabled="medicineList.length === 0">
					确认创建
				</el-button>
			</template>

			<!-- 修改模式 -->
			<template v-else-if="mode === 'edit'">
				<el-button size="small" @click="handleClose">
					关闭
				</el-button>
				<el-button type="primary" size="small" @click="handleSave" :loading="saving">
					保存
				</el-button>
				<el-button type="success" size="small" @click="handleSaveAndSubmit" :loading="saving">
					保存提交
				</el-button>
			</template>

			<!-- 提交模式 -->
			<template v-else-if="mode === 'submit'">
				<el-button size="small" @click="handleClose">
					关闭
				</el-button>
				<el-button type="primary" size="small" @click="handleSubmitConfirm" :loading="saving">
					确认提交
				</el-button>
			</template>

			<!-- 审核模式 -->
			<template v-else-if="mode === 'review'">
				<el-button size="small" @click="handleClose">
					关闭
				</el-button>
				<el-button type="warning" size="small" @click="handleRollbackDraft" :loading="saving">
					回退草稿
				</el-button>
				<el-button type="primary" size="small" @click="handleReviewConfirm" :loading="saving">
					确认审核
				</el-button>
			</template>

			<!-- 过单入库模式 -->
			<template v-else-if="mode === 'pass'">
				<el-button size="small" @click="handleClose">
					关闭
				</el-button>
				<el-button type="warning" size="small" @click="handleRollbackReview" :loading="saving">
					回退审核
				</el-button>
				<el-button type="success" size="small" @click="handlePassConfirm" :loading="saving">
					确认入库
				</el-button>
			</template>

			<!-- 回退模式 -->
			<template v-else-if="mode === 'rollback'">
				<el-button size="small" @click="handleClose">
					关闭
				</el-button>
				<el-button type="warning" size="small" @click="handleRollbackConfirm" :loading="saving">
					确认回退
				</el-button>
			</template>
			<!-- 快速调拨模式 -->
			<template v-else-if="mode === 'fast'">
				<el-button size="small" @click="handleClose">
					关闭
				</el-button>
				<el-button type="primary" size="small" @click="handleFastTransferConfirm" :loading="saving">
					确认无误，快速调拨
				</el-button>
			</template>
		</span>

		<!-- 新增供应商模态框 -->
		<el-dialog title="新增供应商" :visible.sync="supplierDialogVisible" width="500px" :close-on-click-modal="false">
			<el-form ref="supplierForm" :model="supplierForm" :rules="supplierRules" label-width="100px" size="small">
				<el-form-item label="供应商名称" prop="supplierName" required>
					<el-input v-model="supplierForm.supplierName" placeholder="请输入供应商名称"></el-input>
				</el-form-item>
				<el-form-item label="联系人" prop="contact" required>
					<el-input v-model="supplierForm.contact" placeholder="请输入联系人"></el-input>
				</el-form-item>
				<el-form-item label="联系人电话" prop="contactPhone" required>
					<el-input v-model="supplierForm.contactPhone" placeholder="请输入联系人电话"></el-input>
				</el-form-item>
				<el-form-item label="供应商地址" prop="address">
					<el-input v-model="supplierForm.address" placeholder="请输入供应商地址"></el-input>
				</el-form-item>
				<el-form-item label="许可证号" prop="permitNumber">
					<el-input v-model="supplierForm.permitNumber" placeholder="请输入许可证号"></el-input>
				</el-form-item>
				<el-form-item label="状态" prop="status" required>
					<el-select v-model="supplierForm.status" placeholder="请选择状态" style="width: 100%">
						<el-option label="禁用" :value="0"></el-option>
						<el-option label="启用" :value="1"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="备注" prop="remark">
					<el-input v-model="supplierForm.remark" type="textarea" :rows="2" placeholder="请输入备注"></el-input>
				</el-form-item>
			</el-form>
			<span slot="footer" class="dialog-footer">
				<el-button size="small" @click="supplierDialogVisible = false">取消</el-button>
				<el-button type="primary" size="small" @click="handleSaveSupplier"
					:loading="supplierSaving">保存</el-button>
			</span>
		</el-dialog>

		<!-- 新增厂商模态框 -->
		<man-facter :visible="manufacturerDialogVisible" :manufacturerData="currentMedicine" :mode="'add'"
			:drugData="currentDrugData" :existingDrugData="existingDrugData" :drugName="currentDrugName"
			@close="handleCloseManufacturerDialog" @save="handleSaveManufacturer" />

		<!-- 采购计划详情抽屉 -->
		<el-drawer title="选择采购计划详情单" :visible.sync="purchasePlanDrawerVisible" direction="rtl" size="50%"
			:before-close="handleDrawerClose" class="purchase-plan-drawer">
			<div class="drawer-content">
				<!-- 搜索条件 -->
				<div class="drawer-search">
					<el-form :model="planQueryForm" inline class="plan-query-form" size="small">
						<el-form-item label="采购单号：">
							<el-input v-model="planQueryForm.docNum" placeholder="采购单号" clearable
								@keyup.enter="handlePlanQuery" />
						</el-form-item>

						<el-form-item label="开始时间：">
							<el-date-picker v-model="planQueryForm.startTime" type="date" placeholder="开始时间"
								value-format="yyyy-MM-dd" format="yyyy-MM-dd" />
						</el-form-item>

						<el-form-item label="结束时间：">
							<el-date-picker v-model="planQueryForm.endTime" type="date" placeholder="结束时间"
								value-format="yyyy-MM-dd" format="yyyy-MM-dd" />
						</el-form-item>

						<el-form-item>
							<el-button type="primary" @click="handlePlanQuery">查询</el-button>
							<el-button @click="resetPlanQuery">重置</el-button>
						</el-form-item>
					</el-form>
				</div>

				<!-- 采购计划列表 -->
				<div class="drawer-table">
					<el-table :data="purchasePlanList" stripe border style="width: 100%" height="calc(100vh - 250px)"
						v-loading="planLoading" @row-dblclick="handlePlanRowDblClick">
						<el-table-column type="index" label="#" width="50" align="center"></el-table-column>

						<el-table-column prop="docNum" label="采购单号" width="120" show-overflow-tooltip></el-table-column>

						<el-table-column prop="supplierName" label="供应商" width="150"
							show-overflow-tooltip></el-table-column>

						<el-table-column prop="createName" label="创建人" width="100"></el-table-column>

						<el-table-column prop="createTime" label="创建时间" width="120">
							<template slot-scope="scope">
								{{ formatDate(scope.row.createTime) }}
							</template>
						</el-table-column>

						<el-table-column prop="totalAmt" label="采购合计金额" width="120" align="right">
							<template slot-scope="scope">
								¥{{ scope.row.totalAmt ? formatDecimal(scope.row.totalAmt, 8) : '0.00' }}
							</template>
						</el-table-column>

						<el-table-column prop="state" label="状态" width="80" align="center">
							<template slot-scope="scope">
								<el-tag :type="getStatusType(scope.row.state)" size="small">
									{{ getStatusText(scope.row.state) }}
								</el-tag>
							</template>
						</el-table-column>

						<el-table-column label="操作" width="80" align="center">
							<template slot-scope="scope">
								<el-button type="text" size="mini" @click="selectPurchasePlan(scope.row)">
									选择
								</el-button>
							</template>
						</el-table-column>
					</el-table>
				</div>

				<!-- 分页 -->
				<div class="drawer-pagination">
					<el-pagination :current-page="planPagination.currentPage" :page-size="planPagination.pageSize"
						:total="planPagination.total" layout="total, prev, pager, next, jumper"
						@current-change="handlePlanPageChange" size="small" />
				</div>
			</div>
		</el-drawer>
	</el-dialog>
</template>

<script>
	import {
		selectDropDownList,
		getWareZY,
		getProdentZY,
		docMarkById,
		addZYDrugStorage,
		addZYFDrugStorage,
		getPutin,
		getZYPlans,
		getZYPlanData,
		getPurchasingPlanZY,
		toZYFDrugExamine,
		editZYFPurchase
	} from "@/api/PSI.js";
	import {
		addSupplierEntity
	} from "@/api/supplier.js";
	import {
		ZYfastTransfer
	} from "@/api/systemCatalogue/Western.js";
	import {
		getZYDInfos,
		updateZYDrugInformation
	} from "@/api/MedicenCata.js";
	import ManFacter from './ManFacter.vue';

	// 自定义指令：实现下拉框无限滚动
	const elSelectInfiniteScroll = {
		bind(el, binding) {
			const SELECTWRAPPER_DOM = el.querySelector('.el-select-dropdown .el-select-dropdown__wrap');
			if (SELECTWRAPPER_DOM) {
				SELECTWRAPPER_DOM.addEventListener('scroll', function() {
					const condition = this.scrollHeight - this.scrollTop - 1 <= this.clientHeight;
					if (condition) {
						binding.value();
					}
				});
			}
		}
	};

	// 自定义指令：tooltip
	const elTooltip = {
		inserted(el, binding) {
			el.setAttribute('title', binding.value);
		}
	};

	export default {
		name: 'AddzykModal',
		components: {
			ManFacter
		},
		directives: {
			'el-select-infinite-scroll': elSelectInfiniteScroll,
			'el-tooltip': elTooltip
		},
		props: {
			visible: {
				type: Boolean,
				default: false
			},
			mode: {
				type: String,
				default: 'add'
			},
			rowData: {
				type: Object,
				default: () => ({})
			},
			putinTypeList: {
				type: Array,
				default: () => []
			}
		},
		data() {
			return {
				dialogVisible: false,
				loading: false,
				saving: false,
				supplierLoading: false,
				supplierSaving: false,
				supplierDialogVisible: false,
				manufacturerDialogVisible: false,
				// 新增：默认药品列表
				defaultDrugOptions: [],

				// 新增：搜索定时器
				searchTimer: null,
				// 药品搜索相关
				drugSearchLoading: false,
				loadingMoreDrugs: false,
				drugOptions: [],
				drugPageNum: 1,
				drugPageSize: 50,
				drugHasMore: true,
				drugSearchQuery: '',

				// 当前选中的药品和厂商数据
				currentMedicine: null,
				currentDrugData: null,

				// 入库方式列表
				putinTypeListLocal: [],

				// 采购计划相关
				purchasePlanOptions: [],
				planOptionsLoading: false,
				purchasePlanDrawerVisible: false,
				purchasePlanList: [],
				planLoading: false,
				planQueryForm: {
					docNum: '',
					startTime: '',
					endTime: '',
					state: 5
				},
				planPagination: {
					currentPage: 1,
					pageSize: 10,
					total: 0
				},

				// 采购信息表单
				formData: {
					warehouseId: 4,
					purchasePlanId: '',
					businessDate: new Date().toISOString().split('T')[0],
					invoiceNo: '',
					supplierId: '',
					supplierCode: '',
					putinTypeId: 1,
					remark: ''
				},
				formRules: {
					warehouseId: [{
						required: true,
						message: '请选择采购药库',
						trigger: 'change'
					}],
					supplierId: [{
						required: true,
						message: '请选择供货单位',
						trigger: 'change'
					}],
					putinTypeId: [{
						required: true,
						message: '请选择入库方式',
						trigger: 'change'
					}]
				},

				// 供应商表单
				supplierForm: {
					address: "",
					clinicId: 0,
					contact: "",
					contactPhone: "",
					id: 0,
					payAmt: 0,
					permitNumber: "",
					receAmt: 0,
					remark: "",
					status: 0,
					supplierName: ""
				},
				supplierRules: {
					supplierName: [{
						required: true,
						message: '供应商名称为必填项',
						trigger: 'blur'
					}],
					contact: [{
						required: true,
						message: '联系人为必填项',
						trigger: 'blur'
					}],
					contactPhone: [{
						required: true,
						message: '联系人电话为必填项',
						trigger: 'blur'
					}],
					status: [{
						required: true,
						message: '请选择状态',
						trigger: 'change'
					}]
				},
				// 关键词高亮相关
				currentSearchKeyword: '', // 当前搜索关键词
				highlightColor: '#ff6700', // 高亮颜色
				existingDrugData: null, // 存储getZYDInfos接口返回的数据
				currentDrugName: '', // 当前药品名称
				// 新增：允许重新选择药品控制
				allowReselectAll: false, // 允许重新选择药品复选框状态
				// 供货单位列表
				supplierList: [],
				// 药品明细列表
				medicineList: [],
				allDrugOptions: [], // 缓存全部药品列表
				// 汇总信息
				totalInboundQty: 0,
				totalCost: 0,
				totalRetail: 0
			};
		},
		computed: {
			// 新增：调试模式
			isDebugMode() {
				return process.env.NODE_ENV === 'development';
			},
			getDialogTitle() {
				const docNum = this.rowData ? this.rowData.docNum : '';
				const warehouseName = this.formData.warehouseId === 3 ? '中药库' : '中药房';
				const titles = {
					'add': `创建【${warehouseName}】入库单`,
					'view': `查看（${docNum}） - 入库单`,
					'edit': `修改（${docNum}） - 入库单`,
					'submit': `提交（${docNum}） - 入库单`,
					'review': `审核（${docNum}） - 入库单`,
					'pass': `完成入库（${docNum}） - 入库单`,
					'rollback': `回退（${docNum}） - 入库单`,
					'fast': `将中药库 - ${docNum} - 快速调至药房`
				};
				return titles[this.mode] || '入库单';
			},
			warehouseName() {
				return this.formData.warehouseId === 3 ? '中药库' : '中药房';
			},
			computedPutinTypeList() {
				return this.putinTypeListLocal.length > 0 ? this.putinTypeListLocal : this.putinTypeList;
			},

			// 模式判断
			isViewMode() {
				return this.mode === 'view';
			},
			isEditMode() {
				return this.mode === 'edit';
			},
			isSubmitMode() {
				return this.mode === 'submit';
			},
			isReviewMode() {
				return this.mode === 'review';
			},
			isPassMode() {
				return this.mode === 'pass';
			},
			isRollbackMode() {
				return this.mode === 'rollback';
			},
			isFastMode() {
				return this.mode === 'fast';
			},
			isAddMode() {
				return this.mode === 'add';
			}
		},
		watch: {
			visible: {
				immediate: true,
				handler(newVal) {
					this.dialogVisible = newVal;
					if (newVal) {
						this.initData();
						this.loadSuppliers();
						this.loadPutinTypes();
						this.loadPurchasePlanOptions();

						// 加载默认药品列表
						this.loadDefaultDrugs();
					}
				}
			},
			medicineList: {
				handler: function(newVal) {
					this.calculateSummary();
				},
				deep: true
			}
		},
		mounted() {
			// 初始化药品搜索
			this.loadDrugs();
		},
		methods: {
			// 新增：格式化货币金额（千位分隔符，最多8位小数）
			formatCurrency(value) {
				if (value === null || value === undefined || isNaN(value)) {
					return '0';
				}

				const num = parseFloat(value);
				if (isNaN(num)) {
					return '0';
				}

				// 获取整数部分和小数部分
				const parts = num.toString().split('.');
				let integerPart = parts[0];
				let decimalPart = parts[1] || '';

				// 对整数部分添加千位分隔符
				integerPart = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ',');

				// 处理小数部分（最多保留8位，不强制补零）
				if (decimalPart) {
					// 最多保留8位小数
					decimalPart = decimalPart.length > 8 ? decimalPart.substring(0, 8) : decimalPart;
					return `${integerPart}.${decimalPart}`;
				} else {
					return integerPart;
				}
			},

			// // 格式化小数，保留指定位数，不补零
			formatDecimal(value, maxDecimals = 8) {
				if (value === null || value === undefined) return '0';

				const num = parseFloat(value);
				if (isNaN(num)) return '0';

				// 获取实际的小数位数
				const decimalPlaces = (num.toString().split('.')[1] || '').length;
				// 使用实际小数位数，但不超过最大限制
				const places = Math.min(decimalPlaces, maxDecimals);

				return num.toFixed(places);
			},

			// 加载入库方式列表
			async loadPutinTypes() {
				try {
					const response = await getPutin();
					if (response && response.code === 200 && response.data) {
						this.putinTypeListLocal = response.data;
						this.formData.putinTypeId = 1;
					}
				} catch (error) {
					console.error('加载入库方式失败:', error);
					this.$message.error('加载入库方式失败');
				}
			},

			// 加载采购计划下拉选项
			async loadPurchasePlanOptions() {
				this.planOptionsLoading = true;
				try {
					const response = await getZYPlans();
					if (response && response.code === 200) {
						this.purchasePlanOptions = response.data || [];
					}
				} catch (error) {
					console.error('加载采购计划下拉选项失败:', error);
				} finally {
					this.planOptionsLoading = false;
				}
			},

			// 新增：记录药品信息
			logDrugInfo(row, context) {
				if (this.isDebugMode) {
					console.log(`[药品信息] ${context}`, {
						mode: this.mode,
						drugId: row.drugId,
						drugName: row.drugName,
						spec: row.spec,
						packageSpec: row.packageSpec,
						isNewRow: row.isNewRow
					});
				}
			},

			// 采购计划单变化
			handlePlanCodeChange(planId) {
				if (planId) {
					this.loadPurchasePlanDetails(planId);
				} else {
					this.clearPurchasePlanData();
				}
			},

			// 加载采购计划详情
			async loadPurchasePlanDetails(planId) {
				try {
					const response = await getZYPlanData({
						id: planId
					});
					if (response && response.code === 200) {
						this.fillPurchasePlanData(response.data);
					} else {
						this.$message.error(response.message || '获取采购计划详情失败');
					}
				} catch (error) {
					console.error('加载采购计划详情失败:', error);
					this.$message.error('加载采购计划详情失败');
				}
			},

			// 填充采购计划数据
			async fillPurchasePlanData(planData) {
				if (!planData) return;

				this.formData.supplierId = planData.supplierId || '';
				this.formData.supplierCode = planData.supplierCode || '';

				this.medicineList = [];

				if (planData.list && planData.list.length > 0) {
					for (const item of planData.list) {
						const newMedicine = await this.createMedicineFromPlan(item);
						this.medicineList.push(newMedicine);
					}
				}

				this.$message.success('采购计划数据已加载');
			},

			// 从采购计划创建药品明细
			async createMedicineFromPlan(planItem) {
				const newMedicine = {
					id: Date.now() + Math.random(),
					drugId: planItem.drugId || '',
					name: '', // 初始为空，通过getWareZY接口获取
					inboundQty: planItem.purcCnt || 1,
					purcType: planItem.purcType || 2,
					packageQty: planItem.pacCnt || 1,
					manuLotnum: planItem.manuLotnum || '',
					manuDate: planItem.manuDate || '',
					expyDate: planItem.expyDate || '',
					prodentpNameId: planItem.prodentpNameId || '',
					manufacturer: planItem.prodentpName || '',
					manufacturerOptions: [],
					costPric: planItem.purcPric || 0,
					totalCost: 0,
					salePric: planItem.salePric || 0,
					totalRetail: 0,
					markupMethod: planItem.markupMethod || 1,
					spec: planItem.drugSpec || '',
					packageSpec: planItem.pacSpec || '',
					dosUnt: planItem.dosUnt || '单位',
					pacUnt: planItem.pacUnt || '包装单位',
					unitLabel: (planItem.purcType === 1 ? planItem.dosUnt : planItem.pacUnt) || '单位',
					expyDateDisabled: false
				};

				this.calculateRowAmount(newMedicine);

				// 如果药品ID存在，调用getWareZY接口获取药品详细信息
				if (newMedicine.drugId) {
					await this.loadDrugDetailsForPlanItem(newMedicine);
				}

				if (newMedicine.drugId) {
					await this.loadManufacturers(newMedicine);
				}

				return newMedicine;
			},

			// 为采购计划项加载药品详情
			async loadDrugDetailsForPlanItem(medicine) {
				try {
					const response = await getWareZY({
						pageNum: 1,
						pageSize: 1,
						id: medicine.drugId
					});

					if (response && response.code === 200 && response.data) {
						const drugList = response.data.content || response.data;
						if (drugList.length > 0) {
							const drug = drugList[0];

							// 设置加成方式
							medicine.markupMethodText = this.getMarkupMethodText(
								drug.markUpId || 1,
								drug.isFixPrice || 0
							);

							// 设置是否指定售价
							medicine.isFixedPriceText = drug.isFixPrice === 1 ? '已指定' : '未指定';

							// 更新药品信息
							medicine.drugName = drug.drugName || medicine.drugName;
							medicine.spec = drug.drugSpecifications || drug.drugSpec || medicine.spec;
							medicine.packageSpec = drug.pacSpec || medicine.packageSpec;

							// 将药品添加到下拉选项列表中
							if (!this.drugOptions.some(item => item.id === drug.id)) {
								this.drugOptions.push(drug);
							}
						}
					}
				} catch (error) {
					console.error('加载药品详情失败:', error);
				}
			},

			// 清空采购计划数据
			clearPurchasePlanData() {
				this.formData.supplierId = '';
				this.formData.supplierCode = '';
				this.medicineList = [];
			},

			// 打开采购计划抽屉
			openPurchasePlanDrawer() {
				this.purchasePlanDrawerVisible = true;
				this.loadPurchasePlanList();
			},

			// 加载采购计划列表
			async loadPurchasePlanList() {
				this.planLoading = true;
				try {
					const params = {
						pageNum: this.planPagination.currentPage,
						pageSize: this.planPagination.pageSize,
						startTime: this.planQueryForm.startTime,
						endTime: this.planQueryForm.endTime,
						state: this.planQueryForm.state,
						docNum: this.planQueryForm.docNum
					};

					const response = await getPurchasingPlanZY(params);
					if (response && response.code === 200) {
						this.purchasePlanList = response.data.content || response.data || [];
						this.planPagination.total = response.data.totalSize || response.data.totalElements || 0;
					} else {
						this.$message.error(response.message || '加载采购计划列表失败');
					}
				} catch (error) {
					console.error('加载采购计划列表失败:', error);
					this.$message.error('加载采购计划列表失败');
				} finally {
					this.planLoading = false;
				}
			},

			// 采购计划搜索
			handlePlanQuery() {
				this.planPagination.currentPage = 1;
				this.loadPurchasePlanList();
			},

			// 重置采购计划查询
			resetPlanQuery() {
				this.planQueryForm = {
					docNum: '',
					startTime: '',
					endTime: '',
					state: 5
				};
				this.planPagination.currentPage = 1;
				this.loadPurchasePlanList();
			},

			// 采购计划行双击
			handlePlanRowDblClick(row) {
				this.fillPurchasePlanData(row);
				this.purchasePlanDrawerVisible = false;
			},

			// 采购计划行点击
			selectPurchasePlan(row) {
				this.fillPurchasePlanData(row);
				this.purchasePlanDrawerVisible = false;
			},

			// 采购计划分页变化
			handlePlanPageChange(page) {
				this.planPagination.currentPage = page;
				this.loadPurchasePlanList();
			},

			// 获取选中的采购计划信息
			getSelectedPlanInfo() {
				if (!this.formData.purchasePlanId) return '';
				const selectedPlan = this.purchasePlanOptions.find(item => item.id === this.formData.purchasePlanId);
				return selectedPlan ?
					`${selectedPlan.planNo || selectedPlan.docNum} - ${selectedPlan.supplierName || ''}` : '';
			},

			// 获取加成方式显示文字
			getMarkupMethodText(markUpId, isFixPrice) {
				switch (markUpId) {
					case 1:
						return '比例加成';
					case 2:
						return '固定加成';
					case 3:
						return '手工比例加成';
					case 4:
						return '不加成';
					default:
						return '未知';
				}
			},

			// 关闭抽屉
			handleDrawerClose(done) {
				this.$confirm('确认关闭抽屉吗？', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					done();
				}).catch(() => {});
			},

			// 初始化数据
			initData() {
				if (this.mode === 'add') {
					this.resetForm();
				} else if (this.rowData) {
					this.fillDataFromRowData();
				}

				// 加载默认药品列表
				this.loadDefaultDrugs();

				if (this.$refs.inboundForm) {
					this.$refs.inboundForm.clearValidate();
				}
			},

			// 从行数据填充表单
			async fillDataFromRowData() {
				if (!this.rowData) return;

				console.log('从行数据填充表单，行数据:', this.rowData);

				// 保存原始药品数据
				this.originalDrugDetails = this.rowData;

				// 填充采购信息
				this.formData = {
					warehouseId: this.rowData.shedId || 4,
					purchasePlanId: this.rowData.planId || '',
					businessDate: this.rowData.invoDate || new Date().toISOString().split('T')[0],
					invoiceNo: this.rowData.purcInvoCodg || '',
					supplierId: this.rowData.supplyCandidateId || '',
					supplierCode: this.rowData.supplyCode || '',
					putinTypeId: this.rowData.putinTypeId || 1,
					remark: this.rowData.remarks || ''
				};

				// 关键优化：在所有非新增模式下，都需要确保药品信息完整
				if (this.mode !== 'add' && this.rowData.list && this.rowData.list.length > 0) {
					console.log(`${this.mode}模式，开始加载药品信息`);

					// 先创建药品列表
					this.medicineList = [];
					for (const item of this.rowData.list) {
						const newMedicine = await this.createMedicineFromRowData(item);
						this.medicineList.push(newMedicine);
					}

					// 然后确保药品选项中有这些药品
					await this.ensureDrugsInOptions();
				}

				// 计算汇总
				this.calculateSummary();

				console.log('药品明细填充完成:', this.medicineList);
			},

			// 修改：获取药品选项（根据模式）
			getDrugOptionsForMode(row) {
				if (this.mode === 'edit' && !this.allowReselectAll) {
					// 修改模式下，不允许重新选择，从drugOptions中查找当前药品
					if (row.drugId) {
						const currentDrug = this.drugOptions.find(drug => drug.id === row.drugId);
						if (currentDrug) {
							return [currentDrug];
						} else {
							// 如果没有找到，创建临时选项
							return [{
								id: row.drugId,
								drugName: row.drugName || '未知药品',
								label: row.drugName || '未知药品'
							}];
						}
					} else {
						return [];
					}
				} else {
					// 其他模式或允许重新选择，使用全局药品列表
					return this.drugOptions;
				}
			},

			// 新增：确保药品在drugOptions中
			async ensureDrugsInOptions() {
				if (!this.rowData || !this.rowData.list) return;

				console.log(`开始确保药品在drugOptions中，模式：${this.mode}`);

				const drugIds = this.rowData.list
					.filter(item => item.drugId)
					.map(item => item.drugId);

				if (drugIds.length === 0) {
					console.log('没有药品ID需要加载');
					return;
				}

				console.log('需要加载的药品ID:', drugIds);

				// 分批加载缺失的药品
				for (const drugId of drugIds) {
					await this.loadDrugByIdForOptions(drugId);
				}
			},

			// 新增：为药品选项列表加载药品
			// loadDrugByIdForOptions
			async loadDrugByIdForOptions(drugId) {
				try {
					const response = await getWareZY({
						pageNum: 1,
						pageSize: 1,
						id: drugId
					});
					if (response && response.code === 200 && response.data) {
						const drugList = response.data.content || response.data;
						if (drugList.length > 0) {
							const drug = drugList[0];
							// 补充 drugName
							if (!drug.drugName && drug.name) {
								drug.drugName = drug.name;
							}
							const exists = this.drugOptions.some(item => item.id === drug.id);
							if (!exists) {
								this.drugOptions.push(drug);
								console.log('药品已添加到drugOptions:', drug.drugName);
							}
						}
					}
				} catch (error) {
					console.error('为选项列表加载药品失败:', error);
				}
			},

			// loadDrugByIdForDisplay
			async loadDrugByIdForDisplay(medicine) {
				try {
					const response = await getWareZY({
						pageNum: 1,
						pageSize: 1,
						id: medicine.id || medicine.drugId
					});
					if (response && response.code === 200 && response.data) {
						const drugList = response.data.content || response.data;
						if (drugList.length > 0) {
							const drug = drugList[0];
							if (!drug.drugName && drug.name) {
								drug.drugName = drug.name;
							}
							medicine.drugName = drug.drugName || medicine.drugName;
							medicine.spec = drug.drugSpecifications || medicine.spec;
							medicine.packageSpec = drug.pacSpec || medicine.packageSpec;
							if (!this.drugOptions.some(item => item.id === drug.id)) {
								this.drugOptions.push(drug);
							}
						}
					}
				} catch (error) {
					console.error('为显示加载药品失败:', error);
				}
			},

			// 新增：通过ID加载药品（适用于行数据）
			async loadDrugByIdForRowData(drugId) {
				try {
					console.log('通过ID加载药品（行数据）:', drugId);

					// 从行数据中找到对应的药品
					const drugItem = this.rowData.list.find(item => item.drugId === drugId);
					if (!drugItem) {
						console.log('在行数据中未找到药品:', drugId);
						return;
					}

					// 首先尝试通过ID精确匹配
					const response = await getWareZY({
						pageNum: 1,
						pageSize: 1,
						id: drugId
					});

					if (response && response.code === 200 && response.data) {
						const drugList = response.data.content || response.data;
						if (drugList.length > 0) {
							const drug = drugList[0];
							console.log('通过ID找到药品:', drug);

							// 将药品添加到drugOptions中
							if (!this.drugOptions.some(item => item.id === drug.id)) {
								this.drugOptions.push(drug);
								console.log('药品已添加到drugOptions:', drug.drugName);
							}

							return drug;
						} else {
							console.log('通过ID未找到药品，尝试通过名称搜索');
							await this.searchDrugByNameFromRowData(drugId, drugItem);
						}
					}
				} catch (error) {
					console.error('通过ID加载药品失败:', error);
					// 如果通过ID失败，尝试通过名称搜索
					const drugItem = this.rowData.list.find(item => item.drugId === drugId);
					if (drugItem) {
						await this.searchDrugByNameFromRowData(drugId, drugItem);
					}
				}
				return null;
			},

			// 新增：通过行数据中的药品名称搜索药品
			async searchDrugByNameFromRowData(drugId, drugItem) {
				if (!drugItem || !drugItem.drugName) {
					console.log('药品名称为空，无法搜索');
					return;
				}

				console.log('通过药品名称搜索:', drugItem.drugName);

				try {
					const response = await getWareZY({
						pageNum: 1,
						pageSize: 50,
						name: drugItem.name || drugItem.drugName
					});

					if (response && response.code === 200 && response.data) {
						const drugList = response.data.content || response.data;
						console.log('搜索到药品数量:', drugList.length);

						// 在搜索结果中查找匹配的药品
						const foundDrug = drugList.find(drug => {
							// 比较ID是否匹配
							if (drug.id === drugId) {
								return true;
							}
							// 或者比较名称是否相同（去除空格和特殊字符）
							const drugName1 = (drug.drugName || '').trim().toLowerCase();
							const drugName2 = (drugItem.drugName || '').trim().toLowerCase();
							return drugName1 === drugName2;
						});

						if (foundDrug) {
							console.log('通过名称找到药品:', foundDrug);

							// 将药品添加到drugOptions中
							if (!this.drugOptions.some(item => item.id === foundDrug.id)) {
								this.drugOptions.push(foundDrug);
								console.log('药品已添加到drugOptions:', foundDrug.drugName);
							}
						} else {
							console.log('搜索结果中未找到匹配的药品，创建临时药品');
							this.createTemporaryDrugFromRowData(drugItem);
						}
					}
				} catch (error) {
					console.error('通过名称搜索药品失败:', error);
					this.createTemporaryDrugFromRowData(drugItem);
				}
			},

			// 新增：为行数据创建临时药品
			createTemporaryDrugFromRowData(drugItem) {
				const tempDrug = {
					id: drugItem.drugId,
					drugName: drugItem.drugName,
					drugSpecifications: drugItem.drugSpec,
					pacSpec: drugItem.pacSpec,
					markUpId: drugItem.markUpId || 1,
					isFixPrice: drugItem.isFixPrice || 0
				};

				if (!this.drugOptions.some(item => item.id === tempDrug.id)) {
					this.drugOptions.push(tempDrug);
					console.log('已创建临时药品并添加到drugOptions:', tempDrug);
				}
			},

			// 修改：获取药品选项（根据行）
			getDrugOptionsForRow(row) {
				console.log('获取药品选项:', {
					mode: this.mode,
					isNewRow: row.isNewRow,
					drugId: row.drugId,
					drugName: row.drugName,
					isViewOrProcessMode: this.isViewMode || this.isSubmitMode || this.isReviewMode ||
						this.isPassMode || this.isRollbackMode || this.isFastMode
				});

				// 如果是查看、提交、审核、过单、回退、快速调拨等只读模式
				if (this.isViewMode || this.isSubmitMode || this.isReviewMode ||
					this.isPassMode || this.isRollbackMode || this.isFastMode) {
					console.log('只读模式，返回当前药品信息:', row.drugName || row.drugId);

					// 在这些只读模式下，只需要显示当前药品，不需要搜索选项
					if (row.drugId) {
						// 尝试从drugOptions中查找完整的药品信息
						const foundDrug = this.drugOptions.find(drug => drug.id === row.drugId);
						if (foundDrug) {
							console.log('在drugOptions中找到药品:', foundDrug.drugName);
							return [foundDrug];
						} else {
							// 如果没有找到完整药品信息，创建包含药品名称的选项
							return [{
								id: row.drugId,
								drugName: row.drugName || '未知药品',
								label: row.drugName || row.drugId, // 关键修复：使用drugName而不是drugId
								drugSpecifications: row.spec,
								pacSpec: row.packageSpec
							}];
						}
					}
					return [];
				}

				// 如果是新增模式
				if (this.mode === 'add') {
					// 如果有搜索查询，使用搜索结果
					if (row.drugSearchQuery && row.drugSearchQuery.trim()) {
						console.log('新增模式，使用搜索结果:', row.drugSearchResults?.length);
						return row.drugSearchResults || [];
					}
					// 否则使用全局药品列表
					console.log('新增模式，使用全局列表:', this.drugOptions.length);
					return this.drugOptions;
				}

				// 如果是修改模式
				if (this.mode === 'edit') {
					// 如果是新增行
					if (row.isNewRow) {
						// 如果有搜索查询，使用搜索结果
						if (row.drugSearchQuery && row.drugSearchQuery.trim()) {
							console.log('修改模式新增行，使用搜索结果:', row.drugSearchResults?.length);
							return row.drugSearchResults || [];
						}
						// 否则使用全局药品列表
						console.log('修改模式新增行，使用全局列表:', this.drugOptions.length);
						return this.drugOptions;
					}

					// 如果是原始数据行，查找匹配的药品
					if (row.drugId) {
						const foundDrug = this.drugOptions.find(drug => drug.id === row.drugId);
						if (foundDrug) {
							console.log('修改模式原始行，找到匹配药品:', foundDrug.drugName);
							return [foundDrug];
						} else {
							// 如果没有找到，尝试从行数据中获取药品信息
							if (row.drugName) {
								console.log('修改模式原始行，创建临时选项:', row.drugName);
								return [{
									id: row.drugId,
									drugName: row.name || row.drugName,
									label: row.name || row.drugName, // 关键修复：使用drugName而不是drugId
									drugSpecifications: row.spec,
									pacSpec: row.packageSpec
								}];
							} else {
								// 尝试从原始数据加载
								return this.getDrugFromOriginalData(row);
							}
						}
					}
				}

				// 默认情况
				console.log('默认情况，返回空数组');
				return [];
			},

			// 新增：从原始数据加载药品
			getDrugFromOriginalData(row) {
				// 尝试从原始行数据中查找药品
				if (this.rowData && this.rowData.list) {
					const originalItem = this.rowData.list.find(item =>
						item.drugId === row.drugId || item.id === row.id
					);
					if (originalItem && originalItem.drugName) {
						return [{
							id: row.drugId,
							drugName: originalItem.drugName,
							label: originalItem.drugName,
							drugSpecifications: originalItem.drugSpec,
							pacSpec: originalItem.pacSpec
						}];
					}
				}
				return [];
			},

			// 新增：从行数据获取药品信息
			getDrugInfoFromRowData(row) {
				return {
					drugName: row.drugName || '未知药品',
					drugSpecifications: row.spec || '',
					pacSpec: row.packageSpec || '',
					markUpId: row.markUpId || 1,
					isFixPrice: row.isFixPrice || 0,
					costPric: row.costPric || 0,
					dosUnt: row.dosUnt || '单位',
					pacUnt: row.pacUnt || '包装单位'
				};
			},
			// 新增：处理药品下拉框失焦事件
			handleDrugBlur(row) {
				// 只在修改模式的新增行中处理
				if (this.isEditMode && row.isNewRow) {
					// 延迟处理，避免和选择事件冲突
					setTimeout(() => {
						// 如果当前有搜索内容但没有选择药品，清空输入并重新加载全部选项
						if (row.drugSearchQuery && row.drugSearchQuery.trim() && !row.drugId) {
							this.$message.info(`清空搜索内容，重新加载药品列表`);
							this.resetRowDrugSearch(row);
							// 重新加载全部药品列表
							this.loadDefaultDrugs();
						}
					}, 200);
				}
			},

			// 新增：重置行的药品搜索
			resetRowDrugSearch(row) {
				if (row.isNewRow) {
					row.drugSearchQuery = '';
					row.drugSearchResults = [];
				}
			},

			// 新增：显示无搜索数据消息
			showNoSearchDataMessage(row) {
				// 只在修改模式的新增行中显示
				if (this.isEditMode && row.isNewRow) {
					return row.drugSearchQuery &&
						row.drugSearchQuery.trim() &&
						row.drugSearchResults &&
						row.drugSearchResults.length === 0;
				}
				return false;
			},

			// 新增：获取药品显示标签
			getDrugDisplayLabel(drug, row) {
				if (!row) return drug.drugName || drug.name || '';
				if (this.mode !== 'add' && row.drugName) {
					return row.drugName;
				}
				return drug.drugName || drug.name || drug.label || '未知药品';
			},

			// 从行数据创建药品明细
			async createMedicineFromRowData(item) {
				const newMedicine = {
					id: item.id,
					drugId: item.drugId || '',
					drugName: item.name || item.drugName,
					inboundQty: item.purcCnt || 1,
					purcType: item.purcType || 2,
					packageQty: item.pacCnt || 1,
					manuLotnum: item.manuLotnum || '',
					manuDate: item.manuDate || '',
					expyDate: item.expyDate || '',
					prodentpNameId: item.prodentpNameId || '',
					manufacturer: item.prodentpName || '',
					manufacturerOptions: [],
					costPric: item.purcPric || 0,
					totalCost: item.purcAmt || 0,
					salePric: item.salePric || 0,
					totalRetail: item.saleAmt || 0,
					markupMethod: item.markupMethod || 1,
					markupMethodText: this.getMarkupMethodText(item.markUpId || 1, item.isFixPrice || 0),
					isFixedPriceText: '',
					spec: item.drugSpec || '',
					packageSpec: item.pacSpec || '',
					dosUnt: item.dosUnt || '单位',
					pacUnt: item.pacUnt || '包装单位',
					unitLabel: (item.purcType === 1 ? item.dosUnt : item.pacUnt) || '单位',
					expyDateDisabled: false,
					// 修改模式下的原始数据行，标记为非新增行
					isNewRow: false,
					// 添加完整药品信息
					markUpId: item.markUpId || 1,
					isFixPrice: item.isFixPrice || 0
				};

				// 设置是否指定售价
				if (item.isFixPrice !== undefined) {
					newMedicine.isFixedPriceText = item.isFixPrice === 1 ? '已指定' : '未指定';
				}

				// 确保药品信息完整
				await this.ensureDrugDetailsForRow(newMedicine);

				return newMedicine;
			},

			// 新增：为行数据确保药品详情
			async ensureDrugDetailsForRow(medicine) {
				// 如果已经有药品名称，不需要额外处理
				if (medicine.drugName && medicine.drugName.trim() !== '') {
					return;
				}

				// 尝试从drugOptions中查找
				if (medicine.drugId) {
					const foundDrug = this.drugOptions.find(drug => drug.id === medicine.drugId);
					if (foundDrug && foundDrug.drugName) {
						medicine.drugName = foundDrug.drugName;
						medicine.spec = foundDrug.drugSpecifications || medicine.spec;
						medicine.packageSpec = foundDrug.pacSpec || medicine.packageSpec;
						return;
					}
				}

				// 如果还是没有，尝试从接口加载
				if (medicine.drugId) {
					await this.loadDrugByIdForDisplay(medicine);
				}
			},

			// 新增：通过ID加载药品
			async loadDrugById(drugId) {
				try {
					console.log('通过ID加载药品:', drugId);

					const response = await getWareZY({
						pageNum: 1,
						pageSize: 1,
						id: drugId
					});

					if (response && response.code === 200 && response.data) {
						const drugList = response.data.content || response.data;
						if (drugList.length > 0) {
							const drug = drugList[0];
							console.log('通过ID找到药品:', drug);

							// 将药品添加到drugOptions中
							if (!this.drugOptions.some(item => item.id === drug.id)) {
								this.drugOptions.push(drug);
								console.log('药品已添加到drugOptions:', drug.drugName);
							}

							return drug;
						} else {
							console.log('通过ID未找到药品，尝试通过名称搜索');
							await this.searchDrugByNameFromList(drugId);
						}
					}
				} catch (error) {
					console.error('通过ID加载药品失败:', error);
					// 如果通过ID失败，尝试通过名称搜索
					await this.searchDrugByNameFromList(drugId);
				}
				return null;
			},

			// 新增：通过列表中的药品名称搜索药品
			async searchDrugByNameFromList(drugId) {
				// 从行数据中找到对应的药品
				const drugItem = this.rowData.list.find(item => item.drugId === drugId);
				if (!drugItem || !drugItem.drugName) {
					console.log('未找到药品名称，无法搜索');
					return;
				}

				console.log('通过药品名称搜索:', drugItem.drugName);

				try {
					const response = await getWareZY({
						pageNum: 1,
						pageSize: 50,
						name: drugItem.name || drugItem.drugName
					});

					if (response && response.code === 200 && response.data) {
						const drugList = response.data.content || response.data;
						console.log('搜索到药品数量:', drugList.length);

						// 在搜索结果中查找匹配的药品
						const foundDrug = drugList.find(drug => drug.id === drugId);
						if (foundDrug) {
							console.log('通过名称找到药品:', foundDrug);

							// 将药品添加到drugOptions中
							if (!this.drugOptions.some(item => item.id === foundDrug.id)) {
								this.drugOptions.push(foundDrug);
								console.log('药品已添加到drugOptions:', foundDrug.drugName);
							}
						} else {
							console.log('搜索结果中未找到匹配的药品，创建临时药品');
							this.createTemporaryDrug(drugItem);
						}
					}
				} catch (error) {
					console.error('通过名称搜索药品失败:', error);
					this.createTemporaryDrug(drugItem);
				}
			},

			// 新增：创建临时药品
			createTemporaryDrug(drugItem) {
				const tempDrug = {
					id: drugItem.drugId,
					drugName: drugItem.drugName,
					drugSpecifications: drugItem.drugSpec,
					pacSpec: drugItem.pacSpec,
					markUpId: drugItem.markUpId || 1,
					isFixPrice: drugItem.isFixPrice || 0
				};

				if (!this.drugOptions.some(item => item.id === tempDrug.id)) {
					this.drugOptions.push(tempDrug);
					console.log('已创建临时药品:', tempDrug);
				}
			},


			// 新增：确保药品详情完整
			async ensureDrugDetails(medicine) {
				// 如果药品名称不完整，尝试从drugOptions中获取
				if (!medicine.drugName && medicine.drugId) {
					const drug = this.drugOptions.find(d => d.id === medicine.drugId);
					if (drug) {
						medicine.drugName = drug.drugName;
						medicine.spec = drug.drugSpecifications || medicine.spec;
						medicine.packageSpec = drug.pacSpec || medicine.packageSpec;

						// 设置加成方式
						medicine.markupMethodText = this.getMarkupMethodText(
							drug.markUpId || 1,
							drug.isFixPrice || 0
						);

						// 设置是否指定售价
						medicine.isFixedPriceText = drug.isFixPrice === 1 ? '已指定' : '未指定';
					}
				}
			},

			// 重置表单
			resetForm() {
				this.formData = {
					warehouseId: 4,
					purchasePlanId: '',
					businessDate: new Date().toISOString().split('T')[0],
					invoiceNo: '',
					supplierId: '',
					supplierCode: '',
					putinTypeId: 1,
					remark: ''
				};
				this.medicineList = [];
				this.totalInboundQty = 0;
				this.totalCost = 0;
				this.totalRetail = 0;

				// 重置允许重新选择药品状态
				this.allowReselectAll = false;

				// 重置原始药品数据
				this.originalDrugDetails = null;

				// 重置搜索条件
				this.resetDrugSearch();
			},

			// 加载供货单位列表
			async loadSuppliers() {
				this.supplierLoading = true;
				try {
					const response = await selectDropDownList();
					if (response && response.data && response.data.content) {
						this.supplierList = response.data.content;
					}
				} catch (error) {
					console.error('加载供货单位失败:', error);
					this.$message.error('加载供货单位失败');
				} finally {
					this.supplierLoading = false;
				}
			},

			// 加载药品列表
			async loadDrugs(isLoadMore = false) {
				if (!isLoadMore) {
					this.drugSearchLoading = true;
					this.drugPageNum = 1;
				} else {
					this.loadingMoreDrugs = true;
					this.drugPageNum++;
				}

				try {
					const response = await getWareZY({
						pageNum: this.drugPageNum,
						pageSize: this.drugPageSize,
						name: this.drugSearchQuery
					});

					if (response && response.code === 200 && response.data) {
						const newDrugs = response.data.content || response.data;

						if (isLoadMore) {
							this.drugOptions = [...this.drugOptions, ...newDrugs];
						} else {
							this.drugOptions = newDrugs;
						}

						this.drugHasMore = newDrugs.length >= this.drugPageSize;
					}
				} catch (error) {
					console.error('加载药品列表失败:', error);
					this.$message.error('加载药品列表失败');
				} finally {
					this.drugSearchLoading = false;
					this.loadingMoreDrugs = false;
				}
			},

			// 新增：检查是否可以搜索
			canSearchDrug(row) {
				// 新增模式下都可以搜索
				if (this.mode === 'add') {
					return true;
				}

				// 修改模式下，只有新增行可以搜索
				if (this.mode === 'edit') {
					return row.isNewRow;
				}

				return false;
			},

			// 新增：检查是否可以远程搜索
			canRemoteSearch(row) {
				return this.canSearchDrug(row);
			},

			// 新增：检查是否可以清除
			canClearDrug(row) {
				// 新增模式下可以清除
				if (this.mode === 'add') {
					return true;
				}

				// 修改模式下，只有新增行可以清除
				if (this.mode === 'edit') {
					return row.isNewRow;
				}

				return false;
			},

			// 新增：显示无搜索结果提示
			showNoSearchResults(row) {
				// 在新增模式或修改模式的新增行中，如果有搜索查询但没有搜索结果
				if ((this.mode === 'add' || (this.mode === 'edit' && row.isNewRow))) {
					const hasSearchQuery = row.drugSearchQuery && row.drugSearchQuery.trim() ||
						this.drugSearchQuery && this.drugSearchQuery.trim();
					const hasSearchResults = row.drugSearchResults && row.drugSearchResults.length > 0;

					return hasSearchQuery && !hasSearchResults;
				}
				return false;
			},

			// 修改：检查是否可以加载更多
			canLoadMore(row) {
				// 必须有更多数据且不在加载中
				if (!this.drugHasMore || this.drugSearchLoading || this.loadingMoreDrugs) {
					return false;
				}

				// 新增模式下可以加载更多
				if (this.mode === 'add') {
					return true;
				}

				// 修改模式下，只有新增行可以加载更多
				if (this.mode === 'edit') {
					return row.isNewRow;
				}

				return false;
			},

			// 药品搜索
			async handleDrugSearch(query, row) {
				console.log('药品搜索触发:', {
					mode: this.mode,
					query: query,
					rowIndex: this.medicineList.indexOf(row),
					isNewRow: row.isNewRow
				});

				// 保存搜索关键词
				this.currentSearchKeyword = query || '';

				// 检查是否可以搜索
				if (!this.canSearchDrug(row)) {
					console.log('当前不允许搜索药品');
					return;
				}

				// 保存搜索查询
				this.drugSearchQuery = query || '';

				// 为当前行保存搜索查询
				if (row.isNewRow || this.mode === 'add') {
					row.drugSearchQuery = query || '';
				}

				// 如果搜索词为空，清空搜索结果并重置搜索条件
				if (!query || query.trim() === '') {
					console.log('搜索词为空，清空搜索结果并重置');

					// 清空搜索关键词
					this.currentSearchKeyword = '';

					// 清空当前行的搜索结果
					if (row.isNewRow || this.mode === 'add') {
						row.drugSearchResults = [];
					}

					// 重置搜索条件
					this.resetDrugSearch();

					// 重新加载默认药品列表
					this.loadDefaultDrugs();
					return;
				}

				// 重置分页和搜索状态
				this.drugPageNum = 1;
				this.drugHasMore = true;
				this.drugSearchLoading = true;

				// 设置行级加载状态
				if (row.isNewRow || this.mode === 'add') {
					row.drugLoading = true;
				}

				// 清除之前的定时器
				if (this.searchTimer) {
					clearTimeout(this.searchTimer);
				}

				// 设置防抖，避免频繁请求
				this.searchTimer = setTimeout(async () => {
					await this.performDrugSearch(query, row);
				}, 300);
			},

			// 新增：高亮文本中的关键词
			highlightKeyword(text, keyword) {
				if (!text || !keyword || !keyword.trim()) {
					return text || '';
				}

				const searchText = String(text);
				const searchKeyword = String(keyword).trim();

				// 如果搜索关键词为空，返回原文本
				if (!searchKeyword) {
					return searchText;
				}

				try {
					// 创建正则表达式，忽略大小写，使用全局匹配
					const regex = new RegExp(`(${this.escapeRegExp(searchKeyword)})`, 'gi');

					// 替换匹配的关键词为高亮样式
					return searchText.replace(regex, '<span class="highlight-keyword">$1</span>');
				} catch (error) {
					console.error('高亮关键词失败:', error);
					return searchText;
				}
			},

			// 新增：转义正则表达式特殊字符
			escapeRegExp(string) {
				return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
			},

			// 新增：获取高亮后的药品名称
			getHighlightedDrugName(drug, row) {
				if (!row) return drug.name || '';
				const name = this.getDrugDisplayLabel(drug, row) || '';
				if (this.currentSearchKeyword && this.currentSearchKeyword.trim()) {
					return this.highlightKeyword(name, this.currentSearchKeyword);
				}
				return name;
			},

			// 执行药品搜索
			async performDrugSearch(query, row) {
				console.log('执行药品搜索:', query);

				try {
					// 构建搜索参数
					const searchParams = {
						pageNum: this.drugPageNum,
						pageSize: this.drugPageSize
					};

					// 使用合适的参数名drugName
					if (query && query.trim()) {
						// 尝试使用多个可能的参数名
						searchParams.drugName = query.trim(); // 主要使用drugName
						searchParams.name = query.trim(); // 备用参数
					}

					console.log('搜索参数:', searchParams);

					// 调用getWareZY接口
					const response = await getWareZY(searchParams);

					console.log('搜索接口返回:', {
						code: response.code,
						dataCount: response.data?.content?.length || response.data?.length || 0,
						hasData: !!(response.data?.content || response.data)
					});

					if (response && response.code === 200) {
						const newDrugs = response.data?.content || response.data || [];

						console.log('搜索到药品数量:', newDrugs.length);
						console.log('搜索结果前5个:', newDrugs.slice(0, 5));

						// 更新药品选项列表
						this.updateDrugOptionsAfterSearch(newDrugs);

						// 为当前行保存搜索结果
						if (row.isNewRow || this.mode === 'add') {
							row.drugSearchResults = newDrugs;
							console.log('已为当前行保存搜索结果:', row.drugSearchResults.length, '个');
						}

						// 更新是否有更多数据的状态
						this.drugHasMore = newDrugs.length >= this.drugPageSize;

						// 显示搜索成功的消息
						if (newDrugs.length > 0) {
							console.log('搜索成功，找到', newDrugs.length, '个药品');
						} else {
							console.log('未找到相关药品');
							this.$message.info(`未找到 "${query}" 的相关药品`);
						}
					} else {
						console.error('搜索接口返回异常:', response?.message);
						this.$message.error(response?.message || '搜索药品失败');
					}
				} catch (error) {
					console.error('执行药品搜索失败:', error);
					this.$message.error('搜索药品失败: ' + (error.message || '网络错误'));
				} finally {
					this.drugSearchLoading = false;
					if (row.isNewRow || this.mode === 'add') {
						row.drugLoading = false;
					}
				}
			},

			normalizeDrugs(drugs) {
				return drugs.map(item => {
					if (!item.drugName && item.name) {
						item.drugName = item.name;
					}
					// 如果还有其他字段需要补全，可在此添加
					return item;
				});
			},

			// 新增：更新药品选项列表
			updateDrugOptionsAfterSearch(newDrugs) {
				// 规范化药品数据
				const normalizedDrugs = this.normalizeDrugs(newDrugs);

				console.log('更新药品选项列表:', {
					新数据数量: normalizedDrugs.length,
					当前页: this.drugPageNum,
				});

				if (this.drugPageNum === 1) {
					this.drugOptions = normalizedDrugs;
				} else {
					this.drugOptions = [...this.drugOptions, ...normalizedDrugs];
				}

				// 确保数据正确
				this.drugOptions = this.drugOptions.map(drug => {
					// 确保每个药品对象都有必要的字段
					return {
						id: drug.id,
						drugName: drug.drugName || drug.name || drug.label || '未知药品',
						drugSpecifications: drug.drugSpecifications || drug.drugSpec || drug.spec || '',
						pacSpec: drug.pacSpec || drug.packageSpec || '',
						markUpId: drug.markUpId || 1,
						isFixPrice: drug.isFixPrice || 0,
						costPric: drug.costPric || 0,
						dosUnt: drug.dosUnt || '单位',
						pacUnt: drug.pacUnt || '包装单位',
						pacCnt: drug.pacCnt || 1,
						manufacturerName: drug.manufacturerName || drug.manufacturer || '',
						...drug // 保留其他字段
					};
				});

				console.log('更新后的药品选项列表前5个:', this.drugOptions.slice(0, 5));
			},

			// 新增：判断是否可以显示"没有更多"
			canShowNoMore(row) {
				return this.canLoadMore(row);
			},

			// 新增：显示无数据消息
			showNoDataMessage(row) {
				// 只有当有搜索词且没有结果时才显示
				return this.drugSearchQuery &&
					this.drugSearchQuery.trim() &&
					this.drugOptions.length === 0;
			},

			// 药品下拉框获取焦点
			handleDrugFocus(row) {
				console.log('药品下拉框获取焦点:', row);
				if (!row) return;
				// 如果是新增模式或修改模式的新增行
				if (this.mode === 'add' || (this.mode === 'edit' && row.isNewRow)) {
					// 如果有搜索内容，清空并重新加载全部选项
					if (row.drugSearchQuery && row.drugSearchQuery.trim()) {
						console.log('有搜索内容，清空并重置');

						// 清空搜索内容
						row.drugSearchQuery = '';
						row.drugSearchResults = [];
						this.drugSearchQuery = '';

						// 重置搜索条件
						this.resetDrugSearch();

						// 重新加载默认药品列表
						this.loadDefaultDrugs();

						// 显示提示
						this.$message.info('已清空搜索内容，显示全部药品');
					} else {
						// 如果没有搜索内容，加载默认列表
						if (this.drugOptions.length === 0) {
							console.log('没有药品列表，加载默认列表');
							this.loadDefaultDrugs();
						}
					}
				}
			},

			// 药品滚动到底部
			handleDrugScroll(row) {
				// 只在可以加载更多时触发
				if (this.canLoadMore(row) && !this.drugSearchLoading && !this.loadingMoreDrugs) {
					console.log('滚动到底部，加载更多药品');
					this.loadMoreDrugs();
				}
			},

			// 加载更多药品
			async loadMoreDrugs() {
				console.log('加载更多药品，当前页:', this.drugPageNum);

				this.loadingMoreDrugs = true;
				this.drugPageNum++;

				try {
					const searchParams = {
						pageNum: this.drugPageNum,
						pageSize: this.drugPageSize
					};

					// 如果有搜索词，添加到参数中
					if (this.drugSearchQuery && this.drugSearchQuery.trim()) {
						searchParams.name = this.drugSearchQuery;
						searchParams.drugName = this.drugSearchQuery;
					}

					const response = await getWareZY(searchParams);

					if (response && response.code === 200) {
						const newDrugs = response.data?.content || response.data || [];

						// 追加到现有列表
						this.drugOptions = [...this.drugOptions, ...newDrugs];

						// 更新是否有更多数据的状态
						this.drugHasMore = newDrugs.length >= this.drugPageSize;

						console.log('加载更多成功，总药品数:', this.drugOptions.length);
					}
				} catch (error) {
					console.error('加载更多药品失败:', error);
				} finally {
					this.loadingMoreDrugs = false;
				}
			},

			// 药品选择变化
			async handleDrugChange(row) {
				if (!row.drugId) {
					console.log('药品ID为空，重置药品信息');
					this.resetRowDrugInfo(row);
					return;
				}

				console.log('药品选择变化:', row.drugId);

				// 在新增模式下，处理药品变化
				if (this.mode === 'add') {
					const selectedDrug = this.drugOptions.find(item => item.id === row.drugId);
					if (selectedDrug) {
						console.log('选择了新药品:', selectedDrug);

						// 填充药品信息
						row.drugName = selectedDrug.drugName;
						row.spec = selectedDrug.drugSpecifications || selectedDrug.drugSpec || '';
						row.packageSpec = selectedDrug.pacSpec || '';
						row.costPric = selectedDrug.costPric || 0;
						row.packageQty = selectedDrug.pacCnt || 1;
						row.dosUnt = selectedDrug.dosUnt || '单位';
						row.pacUnt = selectedDrug.pacUnt || '包装单位';

						// 设置加成方式显示文字
						row.markupMethodText = this.getMarkupMethodText(
							selectedDrug.markUpId || 1,
							selectedDrug.isFixPrice || 0
						);

						// 设置是否指定售价
						row.isFixedPriceText = selectedDrug.isFixPrice === 1 ? '已指定' : '未指定';
						row.unitLabel = row.purcType === 1 ? row.dosUnt : row.pacUnt;

						// 调用加成接口获取零售价
						await this.loadMarkupInfo(row);
						this.calculateRowAmount(row);
						await this.loadManufacturers(row);
					}
				}

				// 在修改模式下，如果允许重新选择，也处理药品变化
				if (this.mode === 'edit') {
					const selectedDrug = this.drugOptions.find(item => item.id === row.drugId);
					if (selectedDrug) {
						console.log('修改模式下选择了新药品:', selectedDrug);

						// 填充药品信息
						row.drugName = selectedDrug.drugName;
						row.spec = selectedDrug.drugSpecifications || selectedDrug.drugSpec || '';
						row.packageSpec = selectedDrug.pacSpec || '';
						row.costPric = selectedDrug.costPric || 0;
						row.packageQty = selectedDrug.pacCnt || 1;
						row.dosUnt = selectedDrug.dosUnt || '单位';
						row.pacUnt = selectedDrug.pacUnt || '包装单位';

						// 设置加成方式显示文字
						row.markupMethodText = this.getMarkupMethodText(
							selectedDrug.markUpId || 1,
							selectedDrug.isFixPrice || 0
						);

						// 设置是否指定售价
						row.isFixedPriceText = selectedDrug.isFixPrice === 1 ? '已指定' : '未指定';
						row.unitLabel = row.purcType === 1 ? row.dosUnt : row.pacUnt;

						// 调用加成接口获取零售价
						await this.loadMarkupInfo(row);
						this.calculateRowAmount(row);
						await this.loadManufacturers(row);
					}
				}
			},

			// 加载生产厂家
			async loadManufacturers(row) {
				try {
					console.log('加载生产厂家，药品ID:', row.drugId);

					const response = await getProdentZY({
						drugId: row.drugId
					});

					if (response && response.code === 200 && response.data) {
						const manufacturers = Array.isArray(response.data) ? response.data : [response.data];
						row.manufacturerOptions = manufacturers;

						console.log('加载到的生产厂家:', manufacturers);

						// 如果有生产厂家，设置默认值
						if (manufacturers.length > 0) {
							// 如果当前药品有生产厂家ID，查找匹配的生产厂家
							if (row.prodentpNameId) {
								const matchedManufacturer = manufacturers.find(m => m.prodentpId === row
									.prodentpNameId);
								if (matchedManufacturer) {
									row.prodentpNameId = matchedManufacturer.prodentpId;
									row.manufacturer = matchedManufacturer.prodentpName;
								} else {
									// 如果没有匹配的生产厂家，使用第一个
									row.prodentpNameId = manufacturers[0].prodentpId;
									row.manufacturer = manufacturers[0].prodentpName;
								}
							} else {
								// 如果没有生产厂家ID，使用第一个
								row.prodentpNameId = manufacturers[0].prodentpId;
								row.manufacturer = manufacturers[0].prodentpName;
							}
						}
					} else {
						console.log('没有找到生产厂家');
						row.manufacturerOptions = [];
					}
				} catch (error) {
					console.error('加载生产厂家失败:', error);
					row.manufacturerOptions = [];
				}
			},

			// 加载加成信息
			async loadMarkupInfo(row) {
				try {
					const response = await docMarkById({
						drugId: row.drugId,
						costPric: row.costPric || 0,
						purcType: row.purcType || 2,
						drugType: 9
					});

					if (response.code === 200) {
						// 根据库存类型显示不同的零售价
						if (row.purcType === 1) {
							// 最小单位，使用minSalePric
							row.salePric = response.data.minSalePrice;
						} else {
							// 包装单位，使用pacSalePric
							row.salePric = response.data.pacSalePrice;
						}

						this.calculateRowAmount(row);
					} else {
						this.$message.error(response.message || '获取加成信息失败');
					}
				} catch (error) {
					console.error('加载加成信息失败:', error);
					this.$message.error('加载加成信息失败');
				}
			},

			// 成本单价变化
			async handleCostPriceChange(row) {
				if (row.drugId && row.costPric !== undefined) {
					await this.loadMarkupInfo(row);
				}
			},

			// 库存类型变化
			async handlePurcTypeChange(row) {
				if (!row.drugId || !row.packageQty) {
					return;
				}

				const packageQty = row.packageQty || 1;

				if (row.purcType === 2) {
					// 切换到包装单位
					row.inboundQty = (row.inboundQty || 1) / packageQty;
					row.unitLabel = row.pacUnt || '包装单位';
				} else {
					// 切换到最小单位
					row.inboundQty = Math.floor((row.inboundQty || 1) * packageQty) || 1;
					row.unitLabel = row.dosUnt || '单位';
				}

				// 重新调用加成接口，获取对应库存类型的零售价
				if (row.drugId) {
					await this.loadMarkupInfo(row);
				}

				this.calculateRowAmount(row);
			},

			// 厂家变化
			handleManufacturerChange(row) {
				const selectedManufacturer = row.manufacturerOptions.find(item => item.prodentpId === row.prodentpNameId);
				if (selectedManufacturer) {
					row.manufacturer = selectedManufacturer.prodentpName;

					if (row.manuDate) {
						this.calculateExpiryDate(row);
					}
				}
			},

			// 生产日期变化
			async handleManuDateChange(row) {
				if (row.manuDate && row.expyDate) {
					await this.validateDateRange(row);
				}

				if (row.manuDate && row.prodentpNameId) {
					this.calculateExpiryDate(row);
				}
			},

			// 有效日期变化
			async handleExpiryDateChange(row) {
				if (row.manuDate && row.expyDate) {
					await this.validateDateRange(row);
				}
			},

			// 计算有效日期
			calculateExpiryDate(row) {
				if (!row.manuDate || !row.prodentpNameId) return;

				const manufacturer = row.manufacturerOptions.find(item => item.prodentpId === row.prodentpNameId);
				if (manufacturer && manufacturer.expyDate) {
					const manuDate = new Date(row.manuDate);
					const expiryDays = parseInt(manufacturer.expyDate) || 0;

					if (expiryDays > 0) {
						manuDate.setDate(manuDate.getDate() + expiryDays);

						const year = manuDate.getFullYear();
						const month = String(manuDate.getMonth() + 1).padStart(2, '0');
						const day = String(manuDate.getDate()).padStart(2, '0');

						row.expyDate = `${year}-${month}-${day}`;

						this.$nextTick(() => {
							this.validateDateRange(row);
						});
					}
				}
			},

			// 验证日期范围
			async validateDateRange(row) {
				if (!row.manuDate || !row.expyDate) return;

				const manuDate = new Date(row.manuDate);
				const expyDate = new Date(row.expyDate);
				const currentDate = new Date();

				manuDate.setHours(0, 0, 0, 0);
				expyDate.setHours(0, 0, 0, 0);
				currentDate.setHours(0, 0, 0, 0);

				if (expyDate < manuDate) {
					this.$message.warning('有效日期不能小于生产日期');
					row.expyDate = '';
					return false;
				}

				if (expyDate < currentDate) {
					this.$message.warning('有效日期不能小于当前日期');
					row.expyDate = '';
					return false;
				}

				if (manuDate > expyDate) {
					this.$message.warning('生产日期不能大于有效日期');
					row.manuDate = '';
					return false;
				}

				return true;
			},

			// 获取有效日期选择器的限制选项
			getExpiryDatePickerOptions(row) {
				return {
					disabledDate: (time) => {
						const currentDate = new Date();
						currentDate.setHours(0, 0, 0, 0);

						let manuDate = null;
						if (row.manuDate) {
							manuDate = new Date(row.manuDate);
							manuDate.setHours(0, 0, 0, 0);
						}

						if (time < currentDate) {
							return true;
						}

						if (manuDate && time < manuDate) {
							return true;
						}

						return false;
					}
				};
			},

			// 生产日期选择器限制选项
			getManuDatePickerOptions(row) {
				return {
					disabledDate: (time) => {
						let expyDate = null;
						if (row.expyDate) {
							expyDate = new Date(row.expyDate);
							expyDate.setHours(0, 0, 0, 0);
						}

						if (expyDate && time > expyDate) {
							return true;
						}

						return false;
					}
				};
			},

			// 采购药库变化
			handleWarehouseChange(newVal) {
				if (this.mode == 'add') {
					if (newVal !== 3) {
						this.$confirm(
							`请知悉，当前模块为【中药库】，而您已将采购药库切换为了【中药房】，此操作会将采购的药品直接入库至药房中，会省去调拨等相关步骤，请在录入药品的时候进行检查，仔细比对数据的准确性，创建成功后此单据以及后续过单等操作将显示在已采购的【中药房】列表之中。`,
							'切换药库提示', {
								confirmButtonText: '确认切换',
								cancelButtonText: '取消',
								type: 'warning',
								customClass: 'warehouse-change-confirm',
								center: true
							}
						).then(() => {
							this.formData.warehouseId = 4;

							// 如果有未完成的药品信息，清空当前填写的药品数据
							const hasIncompleteData = this.medicineList.some(item =>
								!item.drugId || !item.manuLotnum || !item.manuDate || !item.expyDate || !item
								.prodentpNameId
							);

							if (hasIncompleteData && this.medicineList.length > 0) {
								this.medicineList = [];
								this.$message.info('已清空当前填写的药品数据，请重新添加药品');
							}
						}).catch(() => {
							// 取消切换，恢复原值
							this.formData.warehouseId = oldWarehouse;
						});
					}
				} else {
					// 非新增模式下，不处理切换逻辑
					this.formData.warehouseId = newVal;
				}
			},

			// 供货单位变化
			handleSupplierChange(supplierId) {
				const selectedSupplier = this.supplierList.find(item => item.id === supplierId);
				if (selectedSupplier && selectedSupplier.supplierCode) {
					this.formData.supplierCode = selectedSupplier.supplierCode;
				}
			},

			// 添加供应商
			handleAddSupplier() {
				this.supplierForm = {
					address: "",
					clinicId: 0,
					contact: "",
					contactPhone: "",
					id: 0,
					payAmt: 0,
					permitNumber: "",
					receAmt: 0,
					remark: "",
					status: 0,
					supplierName: ""
				};
				this.supplierDialogVisible = true;
			},

			// 保存供应商
			async handleSaveSupplier() {
				this.$refs.supplierForm.validate(async (valid) => {
					if (valid) {
						this.supplierSaving = true;
						try {
							const response = await addSupplierEntity(this.supplierForm);
							if (response && response.code === 200) {
								this.$message.success('供应商添加成功');
								this.supplierDialogVisible = false;

								await this.loadSuppliers();

								if (response.data && response.data.id) {
									this.formData.supplierId = response.data.id;
								}
							} else {
								this.$message.error(response.message || '添加供应商失败');
							}
						} catch (error) {
							console.error('添加供应商失败:', error);
							this.$message.error('添加供应商失败');
						} finally {
							this.supplierSaving = false;
						}
					}
				});
			},

			// 新增：判断药品是否可以选择
			canSelectDrug(row) {
				// 如果是修改模式
				if (this.isEditMode) {
					// 如果当前行标记为新增行，则可以编辑
					if (row.isNewRow) {
						return true;
					}
					// 如果当前行是原始数据行，则不可编辑
					return false;
				}

				// 其他模式（新增、查看、提交、审核等）按照原有逻辑处理
				if (this.mode === 'add') {
					return true;
				}
				return false;
			},

			// 新增：判断是否可以添加厂商
			canAddManufacturer(row) {
				// 只有在新增模式或者修改模式的新增行，并且选择了药品的情况下才可以添加厂商
				if (this.mode === 'add') {
					return !!row.drugId;
				}

				if (this.isEditMode) {
					// 修改模式下，只有新增行并且选择了药品才可以添加厂商
					return row.isNewRow && !!row.drugId;
				}

				return false;
			},

			// 修改：获取药品选项用于显示
			getDrugOptionsForDisplay(row) {
				// 如果当前有搜索查询，使用搜索结果
				if (this.drugSearchQuery && this.drugSearchQuery.trim()) {
					// 如果搜索后有结果，显示搜索结果
					if (this.drugOptions.length > 0) {
						return this.drugOptions;
					}
					// 如果搜索后没有结果，回退到默认列表
					else {
						return this.defaultDrugOptions || [];
					}
				}

				// 如果没有搜索查询，使用默认选项
				return this.getDefaultDrugOptionsForRow(row);
			},

			// 新增：获取默认药品选项
			getDefaultDrugOptionsForRow(row) {
				// 新增模式下，使用全局药品列表
				if (this.mode === 'add') {
					return this.drugOptions;
				}

				// 非新增模式下
				// 如果当前行有药品ID，查找匹配的药品
				if (row.drugId) {
					const foundDrug = this.drugOptions.find(drug => drug.id === row.drugId);
					if (foundDrug) {
						return [foundDrug];
					} else {
						// 如果没有找到，创建临时选项
						return [{
							id: row.drugId,
							drugName: row.drugName || '未知药品',
							label: row.drugName || '未知药品',
							drugSpecifications: row.spec,
							pacSpec: row.packageSpec
						}];
					}
				} else {
					// 如果没有药品ID，使用全局药品列表
					return this.drugOptions;
				}
			},

			// 处理药品清空事件
			handleDrugClear(row) {
				console.log('药品选择框被清空:', row);
				if (!row) return;
				// 重置当前行的药品信息
				this.resetRowDrugInfo(row);

				// 清空搜索内容
				if (row.isNewRow || this.mode === 'add') {
					row.drugSearchQuery = '';
					row.drugSearchResults = [];
				}

				// 重置搜索条件
				this.resetDrugSearch();

				// 重新加载默认药品列表
				this.loadDefaultDrugs();

				this.$message.info('已清空药品选择，可重新选择');
			},

			// 重置行的药品信息
			resetRowDrugInfo(row) {
				row.drugId = '';
				row.drugName = '';
				row.spec = '';
				row.packageSpec = '';
				row.costPric = 0;
				row.packageQty = 1;
				row.dosUnt = '单位';
				row.pacUnt = '包装单位';
				row.markupMethodText = '';
				row.isFixedPriceText = '';
				row.unitLabel = row.purcType === 1 ? row.dosUnt : row.pacUnt;
				row.totalCost = 0;
				row.totalRetail = 0;
				row.manufacturerOptions = [];
				row.prodentpNameId = '';
				row.manufacturer = '';

				// 清空搜索相关内容
				if (row.isNewRow || this.mode === 'add') {
					row.drugSearchQuery = '';
					row.drugSearchResults = [];
				}

				console.log('药品信息已重置:', row);
			},

			// 新增：重置药品搜索条件
			resetDrugSearch() {
				this.drugSearchQuery = '';
				this.drugPageNum = 1;
				this.drugHasMore = true;

				console.log('药品搜索条件已重置');
			},

			// 加载默认药品列表
			async loadDefaultDrugs() {
				try {
					console.log('加载默认药品列表...');
					this.drugSearchLoading = true;
					this.drugPageNum = 1;
					this.drugHasMore = true;
					this.drugSearchQuery = '';
					const response = await getWareZY({
						pageNum: 1,
						pageSize: this.drugPageSize
					});
					if (response && response.code === 200) {
						const newDrugs = response.data?.content || response.data || [];
						const normalizedDrugs = this.normalizeDrugs(newDrugs);
						this.drugOptions = normalizedDrugs;
						this.allDrugOptions = [...normalizedDrugs]; // 缓存全部
						console.log('默认药品列表已加载:', this.drugOptions.length, '个药品');
					} else {
						console.error('加载默认药品列表失败:', response?.message);
						this.drugOptions = [];
						this.allDrugOptions = [];
					}
				} catch (error) {
					console.error('加载默认药品列表失败:', error);
					this.drugOptions = [];
					this.allDrugOptions = [];
				} finally {
					this.drugSearchLoading = false;
				}
			},

			// 添加药品
			handleAddMedicine() {
				// 过滤掉 null 元素，防止渲染报错
				this.medicineList = this.medicineList.filter(item => item !== null);

				console.log('添加药品按钮被点击，当前模式:', this.mode);

				if (this.medicineList.length > 0) {
					const lastRow = this.medicineList[this.medicineList.length - 1];
					// 增加判空
					if (!lastRow) {
						this.medicineList = this.medicineList.filter(item => item !== null);
						if (this.medicineList.length === 0) {
							this.pushNewMedicine();
							return;
						}
					}
					// 重新获取 lastRow，因为可能被过滤掉
					const lastRowValid = this.medicineList[this.medicineList.length - 1];
					if (!lastRowValid) {
						this.pushNewMedicine();
						return;
					}
					// 校验必填字段（根据中药库字段调整）
					const requiredFields = ['drugId', 'inboundQty', 'manuLotnum', 'manufacturer', 'costPric', 'manuDate',
						'expyDate'
					];
					for (const field of requiredFields) {
						if (!lastRowValid[field] && lastRowValid[field] !== 0) {
							this.$message.warning(`请先完成当前行「${this.getFieldLabel(field)}」的填写`);
							return;
						}
					}
				}

				// 添加新行
				this.pushNewMedicine();
			},

			pushNewMedicine() {
				// 重置全局药品列表为全部药品
				if (this.allDrugOptions && this.allDrugOptions.length > 0) {
					this.drugOptions = [...this.allDrugOptions];
				} else {
					// 缓存为空则重新加载（确保有数据）
					this.loadDefaultDrugs();
				}
				this.drugSearchQuery = '';

				const newMedicine = {
					id: Date.now() + Math.random(),
					drugId: '',
					drugName: '',
					inboundQty: 1,
					purcType: 2,
					packageQty: 1,
					manuLotnum: '',
					manuDate: '',
					expyDate: '',
					prodentpNameId: '',
					manufacturer: '',
					manufacturerOptions: [],
					costPric: 0,
					totalCost: 0,
					salePric: 0,
					totalRetail: 0,
					markupMethod: 1,
					markupMethodText: '',
					isFixedPriceText: '',
					spec: '',
					packageSpec: '',
					dosUnt: '单位',
					pacUnt: '包装单位',
					unitLabel: '包装单位',
					expyDateDisabled: false,
					isNewRow: this.isEditMode,
					drugSearchQuery: '',
					drugSearchResults: [],
					drugLoading: false,
				};

				this.medicineList.push(newMedicine);
				if (this.drugOptions.length === 0) {
					this.loadDefaultDrugs();
				}
			},

			// 添加厂商
			async handleAddManufacturer(row) {
				try {
					this.currentMedicine = row;
					this.currentDrugData = {
						drugName: row.drugName,
						label: row.drugName
					};

					// 调用getZYDInfos接口获取药品已有的厂商信息
					this.loading = true;
					const response = await getZYDInfos({
						id: row.drugId
					});

					if (response && response.code === 200) {
						console.log('获取药品厂商信息成功:', response.data);

						// 保存接口返回的数据
						this.existingDrugData = response.data;
						this.currentDrugName = row.drugName;

						// 打开厂商模态框
						this.manufacturerDialogVisible = true;
					} else {
						this.$message.error(response.message || '获取药品厂商信息失败');
					}
				} catch (error) {
					console.error('获取药品厂商信息失败:', error);
					this.$message.error('获取药品厂商信息失败');
				} finally {
					this.loading = false;
				}
			},

			// 关闭厂商对话框
			handleCloseManufacturerDialog() {
				this.manufacturerDialogVisible = false;
				this.currentMedicine = null;
				this.currentDrugData = null;
			},

			// 保存厂商
			handleSaveManufacturer(manufacturerData) {
				if (this.currentMedicine) {
					// 将新增的厂商信息添加到当前药品的manufacturerOptions中
					this.currentMedicine.manufacturerOptions.push({
						prodentpId: manufacturerData.id || manufacturerData.prodentpId,
						prodentpName: manufacturerData.manufacturerName || manufacturerData.label,
						expyDate: manufacturerData.expyDate
					});

					this.currentMedicine.prodentpNameId = manufacturerData.id || manufacturerData.prodentpId;
					this.currentMedicine.manufacturer = manufacturerData.manufacturerName || manufacturerData.label;

					this.$message.success(`已为${this.currentDrugName}成功添加新的厂商`);
				}
				this.manufacturerDialogVisible = false;
			},

			// 编辑药品
			handleEditMedicine(index, row) {
				console.log('编辑药品:', index, row);
				this.$message.info('编辑药品功能待实现');
			},

			// 移除药品
			handleRemoveMedicine(index, row) {
				// 如果是修改模式的新增行，且没有选择药品，直接移除
				if (this.isEditMode && row.isNewRow && !row.drugId) {
					this.medicineList.splice(index, 1);
					this.$message.success('已移除');
					return;
				}

				// 其他情况需要确认
				const confirmMessage = row.drugName ?
					`您目前已选择了（${row.drugName}），请确认是否继续移除？` :
					'确定移除该药品吗?';

				this.$confirm(confirmMessage, '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.medicineList.splice(index, 1);
					this.$message.success('移除成功');
				}).catch(() => {});
			},

			// 计算单行金额
			calculateRowAmount(row) {
				const inboundQty = parseFloat(row.inboundQty) || 0;
				const costPric = parseFloat(row.costPric) || 0;
				const salePric = parseFloat(row.salePric) || 0;

				row.totalCost = inboundQty * costPric;
				row.totalRetail = inboundQty * salePric;
			},

			// 计算汇总信息
			calculateSummary() {
				this.totalInboundQty = this.medicineList.reduce((sum, item) => {
					return sum + (parseFloat(item.inboundQty) || 0);
				}, 0);

				this.totalCost = this.medicineList.reduce((sum, item) => {
					return sum + (parseFloat(item.totalCost) || 0);
				}, 0);

				this.totalRetail = this.medicineList.reduce((sum, item) => {
					return sum + (parseFloat(item.totalRetail) || 0);
				}, 0);
			},

			// 验证必填字段
			validateRequired(row, field) {
				if (!row[field]) {
					this.$message.warning(`请填写${this.getFieldLabel(field)}`);
				}
			},

			getFieldLabel(field) {
				const fieldLabels = {
					manuLotnum: '生产批号',
					manuDate: '生产日期',
					expyDate: '有效日期',
					prodentpNameId: '生产厂家'
				};
				return fieldLabels[field] || field;
			},

			// 日期格式化
			formatDate(date) {
				if (!date) return '--';
				const d = new Date(date);
				return d.toLocaleDateString('zh-CN');
			},

			// 状态标签类型
			getStatusType(state) {
				switch (state) {
					case 0:
						return 'info';
					case 2:
						return 'warning';
					case 4:
						return 'success';
					case 5:
						return '';
					default:
						return 'info';
				}
			},

			// 状态文本
			getStatusText(state) {
				switch (state) {
					case 0:
						return '草稿';
					case 2:
						return '已提交';
					case 4:
						return '已审核';
					case 5:
						return '已过单';
					default:
						return '未知';
				}
			},

			// 创建入库单
			async handleCreate() {
				this.$refs.inboundForm.validate(async (valid) => {
					if (valid) {
						if (this.medicineList.length === 0) {
							this.$message.warning('请至少添加一个药品明细');
							return;
						}

						const invalidRows = this.medicineList.filter(item =>
							!item.drugId || !item.manuLotnum || !item.manuDate || !item.expyDate || !
							item.prodentpNameId
						);

						if (invalidRows.length > 0) {
							this.$message.warning('请填写完整的药品明细信息（药品名称、生产批号、生产日期、有效日期、生产厂家）');
							return;
						}

						this.saving = true;
						try {
							const submitData = {
								costAmt: this.totalCost,
								invoDate: this.formData.businessDate,
								list: this.medicineList.map(item => ({
									drugId: item.drugId,
									expyDate: item.expyDate,
									manuDate: item.manuDate,
									manuLotnum: item.manuLotnum,
									markUpPric: 0,
									markUpRate: 0,
									planId: this.formData.purchasePlanId,
									prodentpName: item.manufacturer,
									prodentpNameId: item.prodentpNameId,
									purcAmt: item.totalCost,
									purcCnt: item.inboundQty,
									purcPric: item.costPric,
									purcType: item.purcType,
									saleAmt: item.totalRetail,
									salePric: item.salePric
								})),
								printCnt: 0,
								purcInvoCodg: this.formData.invoiceNo,
								putinTypeId: this.formData.putinTypeId,
								remarks: this.formData.remark,
								saleAmt: this.totalRetail,
								shedId: this.formData.warehouseId,
								state: 0,
								supplyCandidateId: this.formData.supplierId,
								supplyCode: this.formData.supplierCode
							};

							console.log('提交入库单数据:', submitData);

							let response;
							if (this.formData.warehouseId === 3) {
								response = await addZYDrugStorage(submitData);
							} else {
								response = await addZYFDrugStorage(submitData);
							}

							if (response && response.code === 200) {
								const warehouseName = this.formData.warehouseId === 3 ? '中药库' : '中药房';
								this.$message.success(`创建【${warehouseName}】采购单成功`);

								// 传递额外的信息给父组件
								this.$emit('success', {
									data: response.data,
									warehouseId: this.formData.warehouseId,
									warehouseName: warehouseName
								});

								// 如果是中药房，触发药库切换事件
								if (this.formData.warehouseId === 4) {
									this.$emit('warehouse-switch', 4);
								}

								this.resetForm();
								this.dialogVisible = false;
							} else {
								this.$message.error(response.message || '创建入库单失败');
							}
						} catch (error) {
							console.error('创建入库单失败:', error);
							this.$message.error('创建入库单失败');
						} finally {
							this.saving = false;
						}
					}
				});
			},

			// 保存（修改模式）
			async handleSave() {
				this.$refs.inboundForm.validate(async (valid) => {
					if (valid) {
						if (this.medicineList.length === 0) {
							this.$message.warning('请至少添加一个药品明细');
							return;
						}

						this.saving = true;
						try {
							const submitData = {
								id: this.rowData ? this.rowData.id : 0,
								costAmt: this.totalCost,
								invoDate: this.formData.businessDate,
								list: this.medicineList.map(item => ({
									drugId: item.drugId,
									expyDate: item.expyDate,
									manuDate: item.manuDate,
									manuLotnum: item.manuLotnum,
									markUpPric: 0,
									markUpRate: 0,
									planId: this.formData.purchasePlanId,
									prodentpName: item.manufacturer,
									prodentpNameId: item.prodentpNameId,
									purcAmt: item.totalCost,
									purcCnt: item.inboundQty,
									purcPric: item.costPric,
									purcType: item.purcType,
									saleAmt: item.totalRetail,
									salePric: item.salePric
								})),
								printCnt: 0,
								purcInvoCodg: this.formData.invoiceNo,
								putinTypeId: this.formData.putinTypeId,
								remarks: this.formData.remark,
								saleAmt: this.totalRetail,
								shedId: this.formData.warehouseId,
								state: 0, // 保存时状态为0（草稿）
								supplyCandidateId: this.formData.supplierId,
								supplyCode: this.formData.supplierCode
							};

							// 调用editZYFPurchase接口
							const response = await editZYFPurchase(submitData);

							if (response && response.code === 200) {
								this.$message.success('修改成功');
								this.$emit('success', submitData);
								this.dialogVisible = false;
							} else {
								this.$message.error(response.message || '修改失败');
							}
						} catch (error) {
							console.error('保存失败:', error);
							this.$message.error('保存失败');
						} finally {
							this.saving = false;
						}
					}
				});
			},

			// 保存并提交（修改模式）
			async handleSaveAndSubmit() {
				this.$refs.inboundForm.validate(async (valid) => {
					if (valid) {
						if (this.medicineList.length === 0) {
							this.$message.warning('请至少添加一个药品明细');
							return;
						}

						this.saving = true;
						try {
							const submitData = {
								id: this.rowData ? this.rowData.id : 0,
								costAmt: this.totalCost,
								invoDate: this.formData.businessDate,
								list: this.medicineList.map(item => ({
									drugId: item.drugId,
									expyDate: item.expyDate,
									manuDate: item.manuDate,
									manuLotnum: item.manuLotnum,
									markUpPric: 0,
									markUpRate: 0,
									planId: this.formData.purchasePlanId,
									prodentpName: item.manufacturer,
									prodentpNameId: item.prodentpNameId,
									purcAmt: item.totalCost,
									purcCnt: item.inboundQty,
									purcPric: item.costPric,
									purcType: item.purcType,
									saleAmt: item.totalRetail,
									salePric: item.salePric
								})),
								printCnt: 0,
								purcInvoCodg: this.formData.invoiceNo,
								putinTypeId: this.formData.putinTypeId,
								remarks: this.formData.remark,
								saleAmt: this.totalRetail,
								shedId: this.formData.warehouseId,
								state: 2, // 保存提交时状态为2（已提交）
								supplyCandidateId: this.formData.supplierId,
								supplyCode: this.formData.supplierCode
							};

							// 调用editZYFPurchase接口
							const response = await editZYFPurchase(submitData);

							if (response && response.code === 200) {
								this.$message.success('保存并提交成功');
								this.$emit('success', submitData);
								this.dialogVisible = false;
							} else {
								this.$message.error(response.message || '保存并提交失败');
							}
						} catch (error) {
							console.error('保存并提交失败:', error);
							this.$message.error('保存并提交失败');
						} finally {
							this.saving = false;
						}
					}
				});
			},

			// 提交确认
			async handleSubmitConfirm() {
				this.saving = true;
				try {
					const response = await toZYFDrugExamine({
						id: this.rowData.id,
						state: 2
					});

					if (response && response.code === 200) {
						this.$message.success('提交成功');
						this.$emit('success', response.data);
						this.dialogVisible = false;
					} else {
						this.$message.error(response.message || '提交失败');
					}
				} catch (error) {
					console.error('提交失败:', error);
					this.$message.error('提交失败');
				} finally {
					this.saving = false;
				}
			},

			// 回退草稿
			async handleRollbackDraft() {
				this.saving = true;
				try {
					const response = await toZYFDrugExamine({
						id: this.rowData.id,
						state: 0
					});

					if (response && response.code === 200) {
						this.$message.success('回退草稿成功');
						this.$emit('success', response.data);
						this.dialogVisible = false;
					} else {
						this.$message.error(response.message || '回退草稿失败');
					}
				} catch (error) {
					console.error('回退草稿失败:', error);
					this.$message.error('回退草稿失败');
				} finally {
					this.saving = false;
				}
			},

			// 审核确认
			async handleReviewConfirm() {
				this.saving = true;
				try {
					const response = await toZYFDrugExamine({
						id: this.rowData.id,
						state: 4
					});

					if (response && response.code === 200) {
						this.$message.success('审核成功');
						this.$emit('success', response.data);
						this.dialogVisible = false;
					} else {
						this.$message.error(response.message || '审核失败');
					}
				} catch (error) {
					console.error('审核失败:', error);
					this.$message.error('审核失败');
				} finally {
					this.saving = false;
				}
			},

			// 回退审核
			async handleRollbackReview() {
				this.saving = true;
				try {
					const response = await toZYFDrugExamine({
						id: this.rowData.id,
						state: 2
					});

					if (response && response.code === 200) {
						this.$message.success('回退审核成功');
						this.$emit('success', response.data);
						this.dialogVisible = false;
					} else {
						this.$message.error(response.message || '回退审核失败');
					}
				} catch (error) {
					console.error('回退审核失败:', error);
					this.$message.error('回退审核失败');
				} finally {
					this.saving = false;
				}
			},

			// 过单入库确认
			async handlePassConfirm() {
				this.saving = true;
				try {
					const response = await toZYFDrugExamine({
						id: this.rowData.id,
						state: 5
					});

					if (response && response.code === 200) {
						this.$message.success('过单入库成功');
						this.$emit('success', response.data);
						this.dialogVisible = false;
					} else {
						this.$message.error(response.message || '过单入库失败');
					}
				} catch (error) {
					console.error('过单入库失败:', error);
					this.$message.error('过单入库失败');
				} finally {
					this.saving = false;
				}
			},

			// 回退确认
			async handleRollbackConfirm() {
				this.saving = true;
				try {
					const response = await toZYFDrugExamine({
						id: this.rowData.id,
						state: 0
					});

					if (response && response.code === 200) {
						this.$message.success('回退成功');
						this.$emit('success', response.data);
						this.dialogVisible = false;
					} else {
						this.$message.error(response.message || '回退失败');
					}
				} catch (error) {
					console.error('回退失败:', error);
					this.$message.error('回退失败');
				} finally {
					this.saving = false;
				}
			},

			// 快速调拨确认方法
			async handleFastTransferConfirm() {
				try {
					this.saving = true;

					// 调用快速调拨接口
					const response = await ZYfastTransfer({
						id: this.rowData.id || 0, // 采购入库单id
					});

					if (response && response.code === 200) {
						this.$message.success('快速调拨成功');
						this.$emit('success', response.data);
						this.dialogVisible = false;

						// 重置表单
						this.resetForm();
					} else {
						this.$message.error(response.message || '快速调拨失败');
					}
				} catch (error) {
					console.error('快速调拨失败:', error);
					this.$message.error('快速调拨失败');
				} finally {
					this.saving = false;
				}
			},

			// 关闭对话框
			handleClose() {
				this.dialogVisible = false;
				this.$emit('close');
			}
		}
	};
</script>

<style lang="less" scoped>
	::v-deep .el-dialog {
		border-radius: 10px;
	}

	::v-deep .el-dialog__body {
		padding: 10px;
	}

	.addxyk-dialog {
		border-radius: 8px;

		.el-dialog__header {
			padding-bottom: 10px;
			border-bottom: 1px solid #e8e8e8;
		}

		.el-dialog__title {
			font-size: 16px;
			color: #333;
			font-weight: 600;
		}

		.section-title {
			font-size: 14px;
			color: #333;
			font-weight: 600;
			margin: 0 0 15px 0;
			padding-bottom: 8px;
			border-bottom: 2px solid #409EFF;
		}

		.purchase-info-section {
			margin-bottom: 10px;
			padding-bottom: 10px;
			border-bottom: 1px solid #e8e8e8;

			.supplier-wrapper {
				display: flex;
				align-items: center;

				.supplier-select {
					flex: 1;
					margin-right: 8px;
				}

				.add-supplier-btn {
					border-color: #409EFF;
					color: #409EFF;
					background-color: #f0f9ff;
					margin-right: 8px;
					padding: 7px 8px;

					&:hover {
						background-color: #409EFF;
						color: white;
					}
				}

				.supplier-code-input {
					width: 140px;
				}
			}

			.plan-code-select {
				display: flex;
				align-items: center;

				.plan-option {
					display: flex;
					flex-direction: column;
					padding: 5px 0;

					.plan-code {
						font-weight: bold;
						color: #333;
						margin-bottom: 2px;
					}

					.plan-supplier {
						font-size: 12px;
						color: #666;
					}
				}
			}

			.selected-plan-info {
				margin-top: 5px;
			}
		}

		.medicine-detail-section {
			.section-header {
				display: flex;
				justify-content: space-between;
				align-items: center;
				margin-bottom: 10px;
			}

			/* 药品选择容器样式 */
			.drug-select-container {
				position: relative;

				.drug-loading-icon {
					position: absolute;
					right: 5px;
					top: 50%;
					transform: translateY(-50%);
				}
			}

			/* 药品选项样式 - 使用参考代码中的样式 */
			.drug-option {
				display: flex;
				flex-direction: column;
				padding: 5px 0;
				line-height: 1.4;

				.drug-name {
					font-weight: bold;
					color: #333;
					margin-bottom: 2px;
				}

				.drug-spec {
					font-size: 12px;
					color: #666;
					margin-top: 1px;

					&:not(:last-child) {
						margin-bottom: 1px;
					}
				}
			}

			/* 加载更多选项样式 */
			.load-more-option {
				text-align: center;
				padding: 8px 0;
				color: #909399;
				cursor: pointer;

				&:hover {
					background-color: #f5f7fa;
				}
			}

			.no-more-option {
				text-align: center;
				padding: 8px 0;
				color: #909399;
			}

			.loading-option {
				text-align: center;
				padding: 8px 0;
				color: #909399;
			}

			.qty-wrapper {
				display: flex;
				align-items: center;

				.qty-input {
					flex: 1;
					margin-right: 8px;
				}

				.unit-label {
					min-width: 40px;
					color: #666;
					font-size: 12px;
					text-align: left;
				}
			}

			.summary-info {
				margin-top: 10px;
				padding: 12px;
				background-color: #f5f7fa;
				border-radius: 4px;

				.summary-item {
					display: flex;
					justify-content: space-between;
					align-items: center;
					font-size: 14px;

					.label {
						color: #606266;
					}

					.value {
						color: #409EFF;
						font-weight: 600;
					}
				}
			}

			.load-more {
				text-align: center;
				padding: 8px;
				color: #909399;
				font-size: 12px;
			}
		}
	}

	/* 采购计划抽屉样式 */
	.purchase-plan-drawer {
		.el-drawer__header {
			margin-bottom: 0;
			padding-bottom: 20px;
			border-bottom: 1px solid #e8e8e8;
		}

		.drawer-content {
			height: 100%;
			display: flex;
			flex-direction: column;
		}

		.drawer-search {
			padding: 20px;
			background-color: #fff;
			border-bottom: 1px solid #e8e8e8;

			.plan-query-form {
				.el-form-item {
					margin-bottom: 10px;
				}
			}
		}

		.drawer-table {
			flex: 1;
			overflow: hidden;
			padding: 20px;

			.el-table {
				height: 100%;
			}
		}

		.drawer-pagination {
			padding: 20px;
			border-top: 1px solid #e8e8e8;
			text-align: right;
		}
	}
</style>

<!-- 药品下拉框全局样式 - 解决样式穿透问题 -->
<style lang="less">
	/* 药品下拉框的全局样式 - 针对挂载在body上的popper */
	.drug-select-popper {
		.el-select-dropdown__item {
			height: auto;
			min-height: 50px;
			padding: 8px 12px;
			display: flex;
			align-items: center;

			&.selected,
			&.hover {
				.drug-option {

					.drug-name,
					.drug-spec {
						color: #409EFF;
					}
				}
			}

			.drug-option {
				display: flex;
				flex-direction: column;
				width: 100%;
				line-height: 1.4;
				min-height: 50px;

				.drug-name {
					font-weight: 600;
					color: #303133;
					margin-bottom: 3px;
					font-size: 13px;
				}

				.drug-spec {
					font-size: 12px;
					color: #606266;
					line-height: 1.3;

					&:not(:last-child) {
						margin-bottom: 2px;
					}
				}
			}
		}

		/* 加载更多、没有更多、加载中的选项样式 */
		.load-more-option,
		.no-more-option,
		.loading-option {
			text-align: center;
			padding: 12px 0;
			color: #909399;
			font-size: 12px;
		}

		.load-more-option {
			cursor: pointer;

			&:hover {
				background-color: #f5f7fa;
			}
		}
	}

	/* 确保采购计划抽屉中的表格样式正确 */
	.purchase-plan-drawer {
		.el-drawer__body {
			display: flex;
			flex-direction: column;
		}

		.drawer-content {
			display: flex;
			flex-direction: column;
			height: 100%;
		}

		.drawer-search {
			flex-shrink: 0;
		}

		.drawer-table {
			flex: 1;
			min-height: 0;
		}

		.drawer-pagination {
			flex-shrink: 0;
		}
	}

	/* 金额输入框的全局样式，确保8位小数显示正确 */
	.el-input-number--small {
		.el-input__inner {
			text-align: right;
		}
	}

	/* 禁用输入框的样式优化 */
	.el-input.is-disabled .el-input__inner {
		background-color: #f5f7fa;
		border-color: #e4e7ed;
		color: #606266;
		cursor: not-allowed;
	}

	/* 表格中tooltip的样式优化 */
	.el-tooltip__popper {
		max-width: 300px;
		word-break: break-word;
	}
</style>
<style lang="less">
	/* 药品下拉框的全局样式 - 针对挂载在body上的popper */
	.drug-select-popper {
		.el-select-dropdown__item {
			height: auto;
			min-height: 50px;
			padding: 8px 12px;
			display: flex;
			align-items: center;

			&:hover,
			&.selected,
			&.hover {
				.drug-option {
					.drug-name {
						.highlight-keyword {
							color: #ff6700;
							background-color: rgba(255, 103, 0, 0.15);
						}
					}
				}
			}

			.drug-option {
				display: flex;
				flex-direction: column;
				width: 100%;
				line-height: 1.4;
				min-height: 50px;

				.drug-name {
					font-weight: 600;
					color: #303133;
					margin-bottom: 3px;
					font-size: 13px;

					/* 高亮关键词样式 */
					.highlight-keyword {
						color: #ff6700;
						font-weight: bold;
						background-color: rgba(255, 103, 0, 0.1);
						padding: 0 2px;
						border-radius: 2px;
					}
				}

				.drug-spec {
					font-size: 12px;
					color: #606266;
					line-height: 1.3;

					&:not(:last-child) {
						margin-bottom: 2px;
					}
				}
			}
		}
	}
</style>

<style lang="less" scoped>
	/deep/ .el-dialog__header {
		padding-bottom: 10px;
		background: linear-gradient(135deg, #ebfaff 0%, #00557f 100%);
		border-bottom: 1px solid #e8e8e8;
		border-radius: 8px;
	}

	/deep/ .el-dialog__headerbtn .el-dialog__close {
		color: #ffffff;
	}

	/deep/ .el-dialog__headerbtn .el-dialog__close:hover {
		color: #000042;
		font-weight: bold;
	}
</style>